<template>
    <div class="page-layout blank contacts-manage">
        <div class="pb-10 pl-3 pr-3">
            <h2 class="ml-0 mb-0 mt-0">
                <div class="d-flex flex-wrap justify-content-between">
                    <!-- Breadcrumb Section -->
                    <div class="breadcrumbactive">
                        <div>
                            <span>Campaigns</span>
                            <span><router-link to="/campaign/email/campaignEmailListView/" class="text-white pl-2 text-line">Email</router-link></span>
                            <div v-if="$route.params.id">Edit Campaign</div>
                            <div v-else>Create Campaign</div>
                            <!-- <div>{{ $route.params.id == 'new' ? 'Create Deals' : 'Edit Deals'}}</div> -->
                        </div>
                    </div>
                </div>
            </h2>
            <div class="d-flex align-items-center justify-content-center h-100" v-if="ajaxCallInProgress">
                <half-circle-spinner :animation-duration="1000" :size="60" color="#00448b" style="margin: 0 auto;" />
            </div>
            <div v-else class="start-overflow">
                <div class="create-company-container w-100">
                    <div class="main-div pt-6">
                        <div class="create-company-header d-flex align-items-center justify-content-between">
                            <span class="fs-14  pl-4 text-white ml-8 fw-500">Campaign Information</span>
                        </div>
                        <div>
                            <!-- Campaign Information Section -->
                            <div class="mt-6 px-10" >
                                <div class="pt-6 pl-6 pr-6 pb-2">
                                    <div class="row">
                                        <div class="col-lg-4 col-md-4 col-sm-12">
                                            <div class="w-100">
                                                <span class="input-label">Campaign Name <sup class="fs-14 text-danger">*</sup></span>
                                                <div class="d-flex align-content-center mt-2">
                                                    <input type="text" ref="campaign_nameInput" autocomplete="off" name="campaign_name" v-validate="'required'" class="input-field input-width" maxlength="100" v-model="createJson.campaign_name" placeholder="Campaign Name" />
                                                </div>
                                                <div class="text-right pr-10">
                                                    <span class="float-left text-danger mb-3" v-show="errors.has('campaign_name')">Campaign Name is Required</span>
                                                </div>
                                                <div class="text-right mt-1">
                                                    <span class="input-field-length float-right">{{ 0 + createJson.campaign_name.length }}/100</span>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-lg-4 col-md-4 col-sm-12">
                                            <div class="w-100">
                                                <span class="input-label">Author Name <sup class="fs-14 text-danger">*</sup></span>
                                                <div class="d-flex align-content-center mt-2">
                                                    <input type="text" name="author_name" disabled class="input-field input-width" v-validate="'required'" v-model="createJson.author_name" placeholder="Author Name" />
                                                    <span class="mt-4 ml-1">
                                                        <span class="mt-3"><i class="icon text-green icon-check-circle"></i></span>
                                                    </span>
                                                </div>
                                                <div class="text-right pr-10">
                                                    <span class="float-left text-danger mb-3" v-show="errors.has('author_name')">Author Name is Required</span>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-lg-4 col-md-4 col-sm-12 margin-res-mx-767">
                                            <div class="w-100">
                                                <span class="input-label">Author's Email Address <sup class="fs-14 text-danger">*</sup></span>
                                                <div class="d-flex align-content-center mt-2">
                                                    <input type="text" name="author_email" disabled class="input-field input-width" v-validate="'required'" v-model="createJson.author_email" placeholder="Author Name" />
                                                    <span class="mt-4 ml-1">
                                                        <span class="mt-3"><i class="icon text-green icon-check-circle"></i></span>
                                                    </span>
                                                </div>
                                                <div class="text-right pr-10">
                                                    <span class="float-left text-danger mb-3" v-show="errors.has('author_email')">Author's Email is Required</span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="row">
                                        <!-- <div class="col-lg-4 col-md-4 col-sm-12">
                                            <div class="d-flex align-items-center">
                                                <div class="w-100">
                                                    <span class="input-label">Industry Type <sup class="fs-14 text-danger">*</sup></span>
                                                    <multiselect v-validate="'required'" ref="industry_type_multiselectInput"
                                                        class="diginew-multiselect new-align-multi customer-multiselect no-default-icon down-arrow mt-2"
                                                        :searchable="true" :options="industries" name="industry_type_multiselect"
                                                        v-model="createJson.industry_type" placeholder="Select Industry Type">
                                                        <template slot="noOptions">
                                                            <div class="text-secondary text-center fw-600">Industry Types not found
                                                            </div>
                                                        </template>
                                                        <template slot="noResult">
                                                            <div class="text-secondary text-center fw-600">No Results Found</div>
                                                        </template>
                                                    </multiselect>
                                                    <div class="text-right pr-10">
                                                        <span class="float-left text-danger mb-3"
                                                            v-show="errors.has('industry_type_multiselect')">Industry Type is Required</span>
                                                    </div>
                                                </div>
                                                <span class="mt-8">
                                                    <i class="icon icon-check-circle fs-30 ml-2 text-green"></i>
                                                </span>
                                            </div>
                                        </div> -->
                                        <div class="col-lg-4 col-md-4 col-sm-12 mt-3">
                                            <div class="w-100">
                                                <span class="input-label">Campaign Type <sup class="fs-14 text-danger">*</sup></span>
                                                <div class="d-flex align-content-center mt-2">
                                                    <input type="text" name="campaign_type" disabled class="input-field input-width text-capitalize" v-validate="'required'" v-model="createJson.campaign_type" placeholder="Campaign Type" />
                                                    <span class="mt-4 ml-1">
                                                        <span class="mt-3"><i class="icon text-green icon-check-circle"></i></span>
                                                    </span>
                                                </div>
                                                <div class="text-right pr-10">
                                                    <span class="float-left text-danger mb-3" v-show="errors.has('campaign_type')">Campaign Type is Required</span>
                                                </div>
                                            </div>
                                        </div>
                                        <!-- <div class="col-lg-4 col-md-4 col-sm-12 margin-res-mx-767">
                                            <div class="row">
                                                <div class="col-lg-3 col-md-3 col-sm-6">
                                                    <span class="input-label">
                                                        Budget
                                                    </span>
                                                    <div class="d-flex align-items-center mt-2">
                                                        <input type="text" disabled name="currency" v-model="createJson.currency" class="input-field input-width text-center"  placeholder="$" />
                                                    </div>
                                                </div>
                                                <div class="col-lg-9 col-md-9 col-sm-6 pl-2 margin-res-mx-575">
                                                   <span class="input-label" style="visibility: hidden;">
                                                        Budget
                                                    </span>
                                                    <div class="d-flex align-items-center mt-2">
                                                        <input type="text" name="budget" autocomplete="off" maxlength="15" class="input-field input-width" v-validate="{regex: /^-?\d+(?:\.\d?\d)?$/}" @keypress="isNumber($event)" :onfocusout="evaluvateData()" v-model="createJson.budget" placeholder="Enter Budget Value" />
                                                    </div>
                                                    <div class="text-right pr-10">
                                                        <span class="float-left text-danger" v-show="errors.has('budget')">Invalid Budget Value</span>
                                                    </div>
                                                </div>
                                            </div>
                                        </div> -->
                                        <div class="col-lg-4 col-md-4 col-sm-12 margin-res-mx-767 mt-3">
                                            <!-- <div class="row">
                                                <div class="col-lg-8 col-md-8 col-sm-6"> -->
                                                    <span class="input-label">
                                                        Broadcast
                                                    </span>
                                                    <div class="d-flex align-items-center">
                                                        <multiselect
                                                            class="diginew-multiselect new-align-multi customer-multiselect no-default-icon down-arrow mt-2"
                                                            :searchable="true" :options="recurrencedays" name="recurrence_days"
                                                            :disabled="disable_broadcast == true"
                                                            @select="selectBroadcast($event)" :allow-empty="false"
                                                            v-model="createJson.recurrence_days" placeholder="Select Broadcast">
                                                            <template slot="noOptions">
                                                                <div class="text-secondary text-center fw-600">Broadcast not found
                                                                </div>
                                                            </template>
                                                            <template slot="noResult">
                                                                <div class="text-secondary text-center fw-600">No Results Found</div>
                                                            </template>
                                                        </multiselect>
                                                        <span v-if="disable_broadcast == false" class="mt-3 ml-1"><i class="icon text-orange icon-check-circle"></i></span>
                                                        <span v-else class="mt-3 ml-1"><i class="icon text-green icon-check-circle"></i></span>
                                                    </div>
                                                <!-- </div> -->
                                                <!-- <div class="col-lg-4 col-md-4 col-sm-6 pl-2">
                                                    <span class="input-label" style="visibility: hidden;">
                                                        Recurrence
                                                    </span>
                                                    <div class="d-block align-items-center mt-1">
                                                        <multiselect
                                                            class="diginew-multiselect new-align-multi customer-multiselect no-default-icon down-arrow mt-2"
                                                            :searchable="true" :options="recurrencenumbers" name="recurrence_nos"
                                                            v-model="recurrence_nos" placeholder="Select">
                                                            <template slot="noOptions">
                                                                <div class="text-secondary text-center fw-600">Recurrence not found
                                                                </div>
                                                            </template>
                                                            <template slot="noResult">
                                                                <div class="text-secondary text-center fw-600">No Results Found</div>
                                                            </template>
                                                        </multiselect>

                                                    </div>
                                                </div> -->
                                            <!-- </div> -->
                                        </div>
                                        <div class="col-lg-4 col-md-4 col-sm-12 mt-3">
                                            <div class="row">
                                                <div class="col-lg-12 col-md-12 col-sm-12">
                                                    <span class="input-label">
                                                        Broadcast Start Date <sup class="fs-14 text-danger">*</sup>
                                                    </span>
                                                    <div class="d-flex align-items-center mt-2">
                                                        <date-picker v-model="createJson.start_date" name="start_date"
                                                            :not-before="new Date()"
                                                            class="meetinfdatetime mx-left calendar-edit-per mr-1"
                                                            format="YYYY-MM-DD" value-type="format" type="date" lang="en"
                                                            placeholder="Select Start Date"
                                                            @change="changeStartDate($event), CheckDate(), disablePreTime()"
                                                            :clearable="false" :editable="false" confirm confirm-text="APPLY">
                                                        </date-picker>
                                                        <span class="mt-3"><i class="icon text-orange icon-check-circle"></i></span>
                                                    </div>
                                                    <span class="invalid-feedback-form text-danger" v-if="is_start_date">
                                                        Start Date is required.
                                                    </span>
                                                </div>
                                                <!-- <div class="col-lg-4 col-md-4 col-sm-6 pl-0">
                                                    <span class="input-label">
                                                    Time <sup class="fs-14 text-danger">*</sup>
                                                    </span>
                                                    <div class="d-flex align-items-center"> -->
                                                        <!-- <date-picker
                                                            type="time"
                                                            v-model="createJson.start_time"
                                                            name="start_time"
                                                            class="meetinfdatetime mx-left calendar-edit-per mr-1 calendar-down-arrow-grey no-down-arrow-autofill"
                                                            format="HH:mm"
                                                            placeholder="HH:MM"
                                                            value-type="format"
                                                            lang="en"
                                                            :clearable="false"
                                                            :editable="false"
                                                            confirm
                                                            confirm-text="APPLY">
                                                        </date-picker> -->
                                                        <!-- <el-select v-validate="'required'" ref="start_timeInput" name="start_time" class="mt-2 schedule_time" v-model="createJson.start_time" style="border-radius: 6px;border: 1px solid rgb(92 92 92) !important;"
                                                        placeholder="Start Time" :popper-append-to-body="false" @change="CheckDate(), resetEndDateTime()">
                                                            <el-option
                                                                v-for="(item, index) in start_date_time_format"
                                                                :key="index"
                                                                :label="item"
                                                                :value="item">
                                                            </el-option>
                                                        </el-select>
                                                        <span class="mt-3"><i class="icon text-orange icon-check-circle"></i></span>
                                                    </div>
                                                    <span class="invalid-feedback-form text-danger" v-if="is_start_time && createJson.start_time == ''">Start Time is required.</span>
                                                </div> -->
                                            </div>
                                        </div>
                                        <div class="col-lg-4 col-md-4 col-sm-12 margin-res-mx-767 mt-3">
                                            <div class="row">
                                                <div v-if="callDisable == true" class="col-lg-12 col-md-12 col-sm-12">
                                                    <span class="input-label">
                                                        Broadcast End Date
                                                    </span>
                                                    <div class="d-flex align-items-center mt-2">
                                                        <date-picker v-model="createJson.end_date"
                                                        name="closure_date" class="meetinfdatetime mx-left calendar-edit-per mr-1 calendar-edit-per mr-1 "
                                                        format="YYYY-MM-DD" value-type="format" type="date" lang="en"
                                                        :clearable="false"
                                                        :disabled="callDisable == true"
                                                        :default-value="current_date"
                                                        :not-before="createJson.start_date"
                                                        @change="CheckDate()"
                                                        placeholder="Select End Date"
                                                        :editable="false" confirm confirm-text="APPLY"></date-picker>
                                                    </div>
                                                </div>
                                                <div v-else class="col-lg-12 col-md-12 col-sm-12">
                                                    <span class="input-label">
                                                        Broadcast End Date <sup class="fs-14 text-danger">*</sup>
                                                    </span>
                                                    <div class="d-flex align-items-center mt-2">
                                                        <date-picker v-model="createJson.end_date" v-validate="'required'"
                                                        name="closure_date" class="meetinfdatetime mx-left calendar-edit-per mr-1 calendar-edit-per mr-1 "
                                                        format="YYYY-MM-DD" value-type="format" type="date" lang="en"
                                                        :clearable="false"
                                                        :disabled="callDisable == true"
                                                        :default-value="current_date"
                                                        :not-before="createJson.start_date"
                                                        @change="CheckDate(), changeEndDate($event), disablePreTime()"
                                                        placeholder="Select End Date"
                                                        :editable="false" confirm confirm-text="APPLY"></date-picker>
                                                    </div>
                                                    <span class="invalid-feedback-form text-danger" v-if="is_end_date && createJson.end_date == ''"> End Date is required.</span>
                                                </div>
                                                <!-- <div class="col-lg-4 col-md-4 col-sm-6 pl-1">
                                                    <span class="input-label">
                                                        Time  <sup class="fs-14 text-danger">*</sup>
                                                    </span>
                                                    <div class="d-flex align-items-center"> -->
                                                        <!-- <date-picker
                                                        v-model="createJson.end_time"
                                                        type="time" name="end_time"
                                                        v-validate="'required'"
                                                        class="meetinfdatetime mx-left calendar-edit-per mr-1 calendar-down-arrow-grey hide-seconds date-picker-clock-svg-icon"
                                                        format="HH:mm"
                                                        :minute-step="1"
                                                        placeholder="HH:MM"
                                                        value-type="format"
                                                        lang="en"
                                                        :clearable="false"
                                                        :editable="false"
                                                        confirm
                                                        confirm-text="APPLY">
                                                    </date-picker> -->
                                                        <!-- <el-select v-validate="'required'" name="end_time" ref="end_timeInput" class="mt-2 schedule_time" v-model="createJson.end_time" style="border-radius: 6px;border: 1px solid rgb(92 92 92) !important;"
                                                        placeholder="End Time" @click="CheckDate" :popper-append-to-body="false">
                                                            <el-option
                                                                v-for="(item, index) in end_date_time_format"
                                                                :key="index"
                                                                :label="item"
                                                                :value="item">
                                                            </el-option>
                                                        </el-select>
                                                    </div>
                                                    <span class="invalid-feedback-form text-danger" v-if="is_end_time && createJson.end_time == ''">
                                                        End Time is required.
                                                    </span>
                                                </div> -->
                                            </div>
                                        </div>
                                        <div v-if="createJson.send_now == true" class="col-lg-4 col-md-4 col-sm-12 pl-4 margin-res-mx-767">
                                            <span class="input-label">
                                                Broadcast Time
                                            </span>
                                            <div>
                                                <el-select :disabled="createJson.send_now == true" ref="start_timeInput" name="start_time" class="mt-2 schedule_time" v-model="createJson.start_time" style="border-radius: 6px;border: 1px solid rgb(92 92 92) !important;display: block;"
                                                    placeholder="Select Time" :popper-append-to-body="false" @change="CheckDate()">
                                                    <el-option
                                                        v-for="(item, index) in start_date_time_format"
                                                        :key="index"
                                                        :label="item"
                                                        :value="item">
                                                    </el-option>
                                                </el-select>
                                            </div>
                                        </div>
                                        <div v-else class="col-lg-4 col-md-4 col-sm-12 pl-4 margin-res-mx-767 mt-3">
                                            <span class="input-label">
                                                Broadcast Time <sup class="fs-14 text-danger">*</sup>
                                            </span>
                                            <div>
                                                <el-select :disabled="createJson.send_now == true" v-validate="'required'" ref="start_timeInput" name="start_time" class="mt-2 schedule_time" v-model="createJson.start_time" style="border-radius: 6px;border: 1px solid rgb(92 92 92) !important;display: block;"
                                                    placeholder="Select Time" :popper-append-to-body="false" @change="CheckDate()" @click="disablePreTime()">
                                                    <el-option
                                                        v-for="(item, index) in start_date_time_format"
                                                        :key="index"
                                                        :label="item"
                                                        :value="item">
                                                    </el-option>
                                                </el-select>
                                            </div>
                                            <span class="invalid-feedback-form text-danger" v-if="is_start_time && createJson.start_time == ''">Start Time is required.</span>
                                        </div>
                                    </div>
                                    <div v-if="callDisable == true" class="row mt-4 ml-0">
                                        <label class="custom-control custom-checkbox digi-checkbox fs-14 fw-600" style="padding-right: 0px !important;">
                                            <input type="checkbox" v-model="createJson.send_now" @change="sendNowChanged" class="custom-control-input" />Send Now
                                            <span class="custom-control-indicator" style="font-size: 20px; top: -10px !important;"></span>
                                            <span class="form-check-description fw-600"></span>
                                        </label>
                                    </div>
                                    <div class="row mt-5">
                                        <div class="col-lg-2 col-md-6 col-sm-12">
                                            <span class="input-label">
                                                Template
                                                <!-- <sup class="fs-14 pl-1 text-danger">*</sup> -->
                                            </span>
                                            <div class="d-flex align-items-center mt-5">
                                                        <!-- <div class="outer-checkbox">
                                                            <div class="inner-checkbox">
                                                                <input type="checkbox" id="template-image" />
                                                                <label for="template-image" />
                                                                <img src="/static/images/suitcase.jpg" alt="">
                                                            </div>
                                                        </div> -->
                                                <div class="row">
                                                    <!-- <div class="col-md-4">
                                                        <div class="custom-control custom-checkbox-image image-checkbox">
                                                            <input type="radio" class="custom-control-input" id="ck1a +'index'" name="radioImg" v-model="createJson.selectedtemplate" value="template1">
                                                            <label class="custom-control-label-image" for="ck1a +'index'">
                                                                <img src="/static/images/template1.webp" name="imgTemp"  alt="#" class="img-fluid img">
                                                                <div class="middle" @click="previewImage(image)">
                                                                    <img src="https://cdn.digicollect.com/cdn/dc_crm_fe/static/images/images/show-password.svg" class="icon-css" >
                                                                    <img :src="image.url1" alt="" style="display: none;">
                                                                </div>
                                                            </label>
                                                        </div>
                                                        <h5 class="templateimage-name">Be Descriptive </h5>
                                                    </div>
                                                    <div class="col-md-4">
                                                        <div class="custom-control custom-checkbox-image image-checkbox">
                                                            <input type="radio" class="custom-control-input" id="ck1b +'index'" name="radioImg" v-model="createJson.selectedtemplate" value="template2">
                                                            <label class="custom-control-label-image" for="ck1b +'index'">
                                                                <img src="/static/images/template2.webp" name="imgTemp"  alt="#" class="img-fluid img">
                                                                <div class="middle" @click="previewImage(image)">
                                                                    <img src="https://cdn.digicollect.com/cdn/dc_crm_fe/static/images/images/show-password.svg" class="icon-css" >
                                                                    <img :src="image.url2" alt="" style="display: none;">
                                                                </div>
                                                            </label>
                                                        </div>
                                                        <h5 class="templateimage-name">Make Offer </h5>
                                                    </div> -->
                                                    <div class="col-md-9" style="max-width: 100%;">
                                                        <div class="custom-control custom-checkbox-image image-checkbox">
                                                            <input type="image" class="custom-control-input" id="ck1c +'index'" name="radioImg" v-model="createJson.selectedtemplate" value="advertised_yours">
                                                            <label class="custom-control-label-image" for="ck1c +'index'">
                                                                <img src="/static/images/template3.webp" name="imgTemp"  alt="#" class="img-fluid img" width="36px" height="40px">
                                                                <div class="middle" @click="previewImage(image)">
                                                                    <img src="https://cdn.digicollect.com/cdn/dc_crm_fe/static/images/images/show-password.svg" class="icon-css" >
                                                                    <img :src="image.url3" alt="" style="display: none;">
                                                                </div>
                                                            </label>
                                                        </div>
                                                        <h5 class="templateimage-name">Advertised Yours </h5>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-lg-10 col-md-6 col-sm-12">
                                            <span class="input-label">
                                                Description
                                            </span>
                                            <div class="d-flex align-items-center mt-2">
                                                <textarea-autosize class="digi-textarea white-background bordered" placeholder="Add Description" maxlength="500" v-model="createJson.description" style="height: 10em; overflow: auto;" />
                                            </div>
                                            <div class="text-right mt-1">
                                                <span class="input-field-length float-right">{{ createJson.description.length }}/500</span>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="row mt-5">
                                        <div class="col-lg-12 col-md-12 col-sm-12">
                                            <span class="input-label">
                                                Recipients <sup class="fs-14 text-danger">*</sup>
                                                <button class="float-right mr-8 add-button" @click="contactsPop()">
                                                    Add+
                                                </button>
                                            </span>
                                            <div class="d-flex align-items-center justify-content-center" v-if="recipientsLoading">
                                                <half-circle-spinner :animation-duration="1000" :size="50" color="#00448b" style="margin: 0 auto;" />
                                            </div>
                                            <div v-else class="d-flex align-items-center mt-2">
                                                <div class="recipients-box">
                                                    <multiselect
                                                        class="diginew-multiselect-longshort greyblack no-default-icon mt-3"
                                                        name="recipients_multiselect"
                                                        ref="recipients_multiselectInput"
                                                        v-validate="'required'" disabled
                                                        v-model="createJson.recipient_details"
                                                        :searchable="true" :block-keys="['Tab']"
                                                        :preserve-search="true"
                                                        placeholder="Select Recipients"
                                                        :options="optionsRecipientsEmpty"
                                                        :multiple="true"
                                                        :close-on-select="false"
                                                        :show-labels="false"
                                                        :clear-on-select="true"
                                                        :hide-selected="false" :taggable="true"
                                                        label="email" track-by="email"
                                                        @tag="addCustomer"
                                                        @remove="removeTag">
                                                        <!-- @tag="addCustomer"
                                                        @search-change="searchCustomerInside"
                                                        @open="searchCustomerInside" -->
                                                        <template slot="tag"
                                                            slot-scope="{ option}">
                                                            <span class="custom__tag" v-if="option.email != ''">
                                                                <span >{{ option.email }}</span>
                                                                <span class="custom__remove"
                                                                    @click="removeTag(option)">
                                                                    <i
                                                                        class="icon-close iconsize-16 defaultDarkBlue"></i>
                                                                </span>
                                                            </span>
                                                        </template>
                                                        <!-- <template slot="afterList">
                                                            <div
                                                                v-observe-visibility="reachedEndOfListCustomer" />
                                                        </template> -->
                                                        <template slot="noOptions">
                                                            <div
                                                                class="text-secondary text-center fw-600">
                                                                List is Empty</div>
                                                        </template>
                                                        <template slot="noResult">
                                                            <div
                                                                class="text-secondary text-center fw-600">
                                                                No Results Found</div>
                                                        </template>
                                                    </multiselect>
                                                    <div class="text-right mt-1">

                                                        <span class="float-left text-danger mb-3" v-show="errors.has('recipients_multiselect')">Recipients are Required</span>
                                                    </div>
                                                </div>
                                                <span class="mt-3 ml-1">
                                                    <img src="/static/images/person-add-green.svg" style="width: 16px;"/>
                                                </span>
                                                <sup style="color:#008a63;font-size: 11px;font-weight: 600;">{{ this.createJson.recipient_details.length }}</sup>
                                            </div>
                                        </div>
                                        <div class="col-lg-12 col-md-12 col-sm-12 mt-5">
                                            <span class="input-label">
                                                Other Recipients
                                            </span>
                                            <div class="d-flex align-items-center mt-2">
                                                <div class="recipients-box">
                                                    <vue-tags-input class="input-height email-text-valid" v-validate="'email'"
                                                        name="other_recipient" placeholder=""
                                                        v-model="tag" 
                                                        :validation="validation"
                                                        :tags="tags"
                                                        @tags-changed="newTags => tags = newTags"
                                                    />
                                                </div>
                                                <span class="mt-3 ml-1">
                                                    <img src="/static/images/person-add-green.svg" style="width: 16px;"/>
                                                </span>
                                                <sup style="color:#008a63;font-size: 11px;font-weight: 600;">{{ this.tags.length }}</sup>
                                            </div>
                                            <span class="text-danger float-left mt-2 pl-2" v-show="errors.has('other_recipient')" style="text-transform: none !important;">Please Enter Valid Email Address</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <!-- Campaign Template Section -->
                            <div class="pt-3 px-17" >
                                <div class="create-company-header d-flex align-items-center justify-content-between">
                                    <span class="fs-14 text-white ml-1 fw-500">Add Template Details</span>
                                </div>
                                <div class="d-flex align-items-center justify-content-center" v-if="ajaxCallLoadContentDetails">
                                    <half-circle-spinner :animation-duration="1000" :size="50" color="#00448b" style="margin: 0 auto;" />
                                </div>
                                <div v-else v-for="(template_data, template_index) in template_details" :key="template_index" class="content-details-div pt-1">
                                    <div class="mt-5 w-100 h-line" style="height: auto;">
                                        <div class="h-label text-black">Content Details (<span v-for="(date, date_index) in template_data.template_dates" :key="date_index">{{date}}<span v-if="date_index != (template_data.template_dates.length - 1)">; </span></span>)</div>
                                    </div>
                                    <div>
                                        <div class="mt-5 w-100 h-line">
                                            <span class="h-label">Info</span>
                                        </div>
                                        <div class="row mt-7 pl-6 pr-6">
                                            <div class="col-lg-8 col-md-8 col-sm-12">
                                                <div class="d-flex align-items-center">
                                                    <div class="w-100">
                                                        <span class="input-label">Topic Name <sup class="fs-14 text-danger">*</sup></span>
                                                        <div class="d-flex align-content-center mt-2">
                                                            <input type="text" :name="'topic_name'+template_index" maxlength="100" autocomplete="off" v-validate="'required'" class="input-field input-width"  v-model="template_data.topic_name" placeholder="Enter Topic Name" />
                                                        </div>
                                                        <div class="text-right mt-1">
                                                            <span class="input-field-length float-right">{{ template_data.topic_name.length }}/100</span>
                                                            <span class="float-left text-danger mb-3" v-show="errors.has('topic_name'+template_index)">Topic Name is Required</span>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="col-lg-4 col-md-4 col-sm-12">
                                                <div class="d-flex align-items-center">
                                                    <div class="w-100">
                                                        <span class="input-label">Hyperlink Button Name <sup class="fs-14 text-danger">*</sup></span>
                                                        <div class="d-flex align-content-center mt-2">
                                                            <input type="url" :name="'headline_url'+template_index" autocomplete="off" v-validate="'required'" maxlength="50" class="input-field input-width"  v-model="template_data.headline_url" placeholder="Add Button Name" />
                                                        </div>
                                                        <div class="text-right mt-1">
                                                            <span class="input-field-length float-right">{{ template_data.headline_url.length }}/50</span>
                                                            <span class="float-left text-danger mb-3" v-show="errors.has('headline_url'+template_index)">Hyperlink Button Name is Required</span>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="row mt-1 pl-6 pr-6">
                                            <div class="col-lg-8 col-md-8 col-sm-12">
                                                <div class="d-flex align-items-center">
                                                    <div class="w-100">
                                                        <span class="input-label">Headline <sup class="fs-14 text-danger">*</sup></span>
                                                        <div class="d-flex align-content-center mt-2">
                                                            <input type="text" :name="'headline'+template_index" autocomplete="off" v-validate="'required'" maxlength="100" class="input-field input-width"  v-model="template_data.headline" placeholder="Add Headline" />
                                                        </div>
                                                        <div class="text-right mt-1">
                                                            <span class="input-field-length float-right">{{ template_data.headline.length }}/100</span>
                                                            <span class="float-left text-danger mb-3" v-show="errors.has('headline'+template_index)">Headline is Required</span>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="col-lg-4 col-md-4 col-sm-12">
                                                <div class="d-flex align-items-center">
                                                    <div class="w-100">
                                                        <span class="input-label">Add Hyperlink to button <sup class="fs-14 text-danger">*</sup></span>
                                                        <div class="d-flex align-content-center mt-2">
                                                            <input type="url" :name="'add_url'+template_index" autocomplete="off" maxlength="50" @input="prefetchURL(template_index, $event)" class="input-field input-width" v-validate="{required: true, url: {require_protocol: true }}" data-vv-as="field" v-model="template_data.add_url" placeholder="https://www.digicollect.com/" />
                                                        </div>
                                                        <div class="text-right mt-1">
                                                            <span class="input-field-length float-right">{{ template_data.add_url.length }}/50</span>
                                                            <span class="float-left text-danger mb-3" v-show="errors.has('add_url'+template_index)">Valid URL is Required</span>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="row mt-1 pl-6 pr-6">
                                            <div class="col-lg-8 col-md-8 col-sm-12">
                                                <div class="d-flex align-items-center">
                                                    <div class="w-100">
                                                        <span class="input-label">Content <sup class="fs-14 text-danger">*</sup></span>
                                                        <div class="d-flex align-content-center mt-2">
                                                            <input type="text" :name="'content'+template_index" autocomplete="off" v-validate="'required'" class="input-field input-width"  v-model="template_data.content" maxlength="100" placeholder="Add Content" />
                                                        </div>
                                                        <div class="text-right mt-1">
                                                            <span class="input-field-length float-right">{{ template_data.content.length }}/100</span>
                                                            <span class="float-left text-danger mb-3" v-show="errors.has('content'+template_index)">Content is Required</span>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="mt-6" >
                                            <div class="mt-5 w-100 h-line">
                                                <span class="h-label">Address Details</span>
                                            </div>
                                            <div class="row mt-7 pl-6 pr-6">
                                                <div class="col-lg-4 col-md-4 col-sm-12">
                                                    <div class="w-100">
                                                        <span class="input-label">Phone Number</span>
                                                        <div class="align-items-center">
                                                            <div class="w-100">
                                                                <vue-tel-input :defaultCountry="template_data.phone_number.country_code || 'US'"
                                                                    @onInput="campaignPhoneInput(template_index, $event)" v-bind="bindProps"
                                                                    class="number-field-width-customer teleContactborderedDark new-align-tel ml-0 mt-3"
                                                                    :name="'campaign_mobile_number'+template_index"
                                                                    autocomplete="off"
                                                                    v-model="template_data.phone_number.number"
                                                                    v-validate="{required:false,min:10}"
                                                                    :valid-characters-only="true" :maxLen="15"
                                                                    placeholder="Enter Mobile Number" :disabledFormatting="false"
                                                                    style="width:100% !important; margin-right: 30px;">
                                                                </vue-tel-input>
                                                            </div>
                                                            <span class="invalid-feedback-form text-danger"
                                                                style="text-transform: none !important;"
                                                                v-show="errors.has('campaign_mobile_number'+template_index)">Phone Number must contain more than 9 numbers
                                                            </span>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="col-lg-8 col-md-8 col-sm-12">
                                                    <span class="input-label">Location</span>
                                                    <div class="d-flex align-items-center mt-3">
                                                        <div class="form-group pt-0 gMap" style="width:180em;">
                                                            <gmap-autocomplete
                                                                class="input-white"
                                                                id="autocompleteInput"
                                                                name="get_location"
                                                                placeholder="Search Location"
                                                                @place_changed="setIndex(template_index, $event)"
                                                                :value="template_data.meeting_location_vmodel"
                                                                v-model="template_data.meeting_location_vmodel"
                                                                style="padding: 6px 32px 6px 12px !important;background-color: #eff3f9">
                                                            </gmap-autocomplete>
                                                            <el-tooltip class="item"
                                                                effect="dark"
                                                                :content="template_data.meeting_location_vmodel"
                                                                placement="top">
                                                                <img src="/static/images/images-new-theme/icons/marker_pin.svg"
                                                                    style="position: absolute;right: 12px;bottom: 10px;" />
                                                            </el-tooltip>
                                                        </div>
                                                        <div class="ml-3" style="cursor: pointer;width:10%;" @click="getLocation(template_index)">
                                                            <img src="/static/images/images-new-theme/icons/GPS 2.svg" style="height: 40px;" />
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <!-- <div class="row mt-3">
                                                <div class="col-lg-4 col-md-4 col-sm-12">
                                                    <div class="d-flex align-items-center">
                                                        <div class="w-100">
                                                            <span class="input-label">Street</span>
                                                            <div class="d-flex align-content-center mt-2">
                                                                <input type="text" name="address"  class="input-field input-width"  v-model="createJson.street" placeholder="Street" />
                                                            </div>
                                                            </div>
                                                    </div>
                                                </div>
                                                <div class="col-lg-4 col-md-4 col-sm-12">
                                                    <div>
                                                        <span class="text-secondary whiteSpace vselectLabel fs-14 fw-600">Country</span>
                                                        <div class="d-flex align-items-center">
                                                            <div class="w-100" >
                                                                <multiselect class="diginew-multiselect new-align-multi no-default-icon down-arrow mt-2" name="country" :searchable="true" :options="countries" v-model="location.country" @select="resetData" placeholder="Select Country">
                                                                    <template slot="noOptions">
                                                                        <div class="text-secondary text-center fw-600">Countries Not Found</div>
                                                                    </template>
                                                                    <template slot="noResult">
                                                                        <div class="text-secondary text-center fw-600">No Results Found</div>
                                                                    </template>
                                                                </multiselect>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="col-lg-4 col-md-4 col-sm-12">
                                                    <div class="d-flex align-items-center">
                                                        <div class="w-100">
                                                            <span class="input-label">State</span>
                                                            <div class="d-flex align-content-center mt-2">
                                                                <input type="text" name="state"  class="input-field input-width"  v-model="createJson.state" placeholder="State" />

                                                            </div>
                                                            </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="row mt-5">
                                                <div class="col-lg-4 col-md-4 col-sm-12">
                                                    <div class="d-flex align-items-center">
                                                        <div class="w-100">
                                                            <span class="input-label">City</span>
                                                            <div class="d-flex align-content-center mt-2">
                                                                <input type="text" name="city" class="input-field input-width" maxlength="15" v-model="createJson.city" placeholder="City" />
                                                            </div>
                                                            <div class="text-right mt-1">
                                                                <span class="input-field-length float-right">{{ 15 - createJson.city.length }}/15</span>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="col-lg-4 col-md-4 col-sm-12">
                                                    <div class="d-flex align-items-center">
                                                        <div class="w-100">
                                                            <span class="input-label">Township</span>
                                                            <div class="d-flex align-content-center mt-2">
                                                                <input type="text" name="content" class="input-field input-width" maxlength="15"  v-model="createJson.township"  placeholder="Township" />
                                                            </div>
                                                            <div class="text-right mt-1">
                                                                <span class="input-field-length float-right">{{ 15 - createJson.township.length }}/15</span>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="col-lg-4 col-md-4 col-sm-12">
                                                    <div class="d-flex align-items-center">
                                                        <div class="w-100">
                                                            <span class="input-label">Pincode</span>
                                                            <div class="d-flex align-content-center mt-2">
                                                                <input type="text" name="zip_code" class="input-field input-width" maxlength="10" v-model="createJson.zip_code"  placeholder="Pincode" />
                                                            </div>
                                                            <div class="text-right mt-1">
                                                                <span class="input-field-length float-right">{{ 10 - createJson.zip_code.length }}/10</span>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div> -->
                                        </div>
                                        <div class="mt-6" >
                                            <div class="mt-5 w-100 h-line">
                                                <span class="h-label">Social Media URLs</span>
                                            </div>
                                            <div class="row mt-6 pl-6 pr-6">
                                                <div class="col-lg-3 col-md-3 col-sm-12">
                                                    <div class="d-flex align-items-center mt-2">
                                                        <input type="url" name="facebook_url_regex" autocomplete="off" v-validate="{url: {require_protocol: true }}" data-vv-as="field" class="input-field icon-data icon-face-link input-width" @input="changeFacebook($event)" @change="changeFacebook($event)" v-model="template_data.facebook_url" placeholder="https://facebook.com/digicollect" />
                                                    </div>
                                                    <div class="text-right mt-1">
                                                        <span class="float-left text-danger mb-3" v-if="!isValidFacebook && template_data.facebook_url != ''">Facebook URL is Invalid</span>
                                                    </div>
                                                </div>
                                                <div class="col-lg-3 col-md-3 col-sm-12">
                                                    <div class="d-flex align-items-center mt-2">
                                                        <input type="url" name="twitter_url_regex" autocomplete="off" v-validate="{url: {require_protocol: true }}" data-vv-as="field" class="input-field icon-data icon-twit-link input-width" @input="changeTwitter($event)" @change="changeTwitter($event)" v-model="template_data.twitter_url" placeholder="https://twitter.com/digicollect" />
                                                    </div>
                                                    <div class="text-right mt-1">
                                                        <span class="float-left text-danger mb-3" v-if="!isValidTwitter && template_data.twitter_url != ''">Twitter URL is Invalid</span>
                                                    </div>
                                                </div>
                                                <div class="col-lg-3 col-md-3 col-sm-12">
                                                    <div class="d-flex align-items-center mt-2">
                                                        <input type="url" name="instagram_url_regex" autocomplete="off" v-validate="{url: {require_protocol: true }}" data-vv-as="field" class="input-field icon-data icon-insta-link input-width" @input="changeInstagram($event)" @change="changeInstagram($event)" v-model="template_data.insta_url" placeholder="https://instagram.com/digicollect" />
                                                    </div>
                                                    <div class="text-right mt-1">
                                                        <span class="float-left text-danger mb-3" v-if="!isValidInstagram && template_data.insta_url != ''">Instagram URL is Invalid</span>
                                                    </div>
                                                </div>
                                                <div class="col-lg-3 col-md-3 col-sm-12">
                                                    <div class="d-flex align-items-center mt-2 ">
                                                        <input type="url" name="linkedin_url_regex" autocomplete="off" v-validate="{url: {require_protocol: true }}" data-vv-as="field" class="input-field icon-data icon-link input-width" @input="changeLinkedin($event)" @change="changeLinkedin($event)" v-model="template_data.linkedin_url" placeholder="https://linkedin.com/digicollect" />
                                                    </div>
                                                    <div class="text-right mt-1">
                                                        <span class="float-left text-danger mb-3" v-if="!isValidLinkedin && template_data.linkedin_url != ''">Linkedin URL is Invalid</span>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="mt-6">
                                            <div class="mt-5 w-100 h-line">
                                                <span class="h-label">Add Images</span>
                                            </div>
                                            <div class="row mt-5 pl-6 pr-6 pb-8">
                                                <div class="col-lg-6 col-md-6 col-sm-6">
                                                    <div class="mt-5 col-md-offset-2 flex-width">
                                                        <div class="stage-sections">
                                                            <span class="fw-500">Logo</span>
                                                            <div class="overflow-auto mx-ht mt-3">
                                                                <div v-if="template_data.showLogoImageUpload" class="upload-main d-flex flex-column justify-content-center align-items-center pl-0 "
                                                                style="border: 3px dashed rgb(224, 224, 224);border-bottom-left-radius: 12px;border-bottom-right-radius: 12px;background-color: #fff;">
                                                                <div id="drop_zone_inside" @drop="dropHandlerLogo($event, template_index)" @dragover="dragOverHandlerLogo($event)" class="img-upload px-3 px-sm-15 pt-3 pb-3 text-center bg-white">
                                                                    <span class="pr-4 hide-on-mob">Drag and Drop Files Here</span><br>
                                                                    <span class="pr-4 hide-on-mob" style="font-weight:400 !important;">or</span><br>
                                                                    <label class="choose-file mt-1 pointer">
                                                                        <img src="/static/images/multimedia.svg" style="width:20px;" alt="">
                                                                        <input type="file" id="upload_inside_reply_file_upload_input_id" name="upload_inside_reply_file_upload" @change="uploadLogoImage($event, template_index)" accept=".jpg, .png, .jpeg">
                                                                        Browse Files
                                                                    </label>
                                                                </div>
                                                                <div>
                                                                    <p class="drag_drop_cond text-center fs-14">
                                                                        Supports .jpg, .png, .jpeg. Size limit - 5.00 MB
                                                                    </p>
                                                                </div>
                                                            </div>
                                                            <div class="p-4" v-for="(attachment) in template_data.logoImage"  :key="attachment.url">
                                                                <div class="overflow-auto mx-ht mt-3 d-flex justify-content-start align-items-top">
                                                                    <span v-if="attachment.progress == 100" class="_images pointer" style="position: relative;" @click="previewImage(attachment)">
                                                                        <img class="att-img pointer" :src="attachment.url" alt="">
                                                                    </span>
                                                                    <span v-else class="_images" style="position: relative;">
                                                                        <img class="att-img" :src="attachment.url" alt="">
                                                                    </span>
                                                                    <div>
                                                                        <div v-if="attachment.uploading || attachment.url == undefined"
                                                                            class="pointer mt-2" @click="deleteLogo(template_index)">
                                                                            <i class="icon icon-close fs-16 closeAttachment"></i>
                                                                        </div>
                                                                        <div v-else class="pointer mt-2" @click="deleteLogo(template_index)">
                                                                            <i class="icon icon-close fs-16 closeAttachment"></i>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                                    <div class="d-flex align-items-center justify-content-between">
                                                                        <div class="d-flex align-items-center">
                                                                            <!-- <div>
                                                                                <img class="icon-img img-file" v-if="attachment.name.endsWith('.jpg')"
                                                                                    src="https://cdn.digicollect.com/cdn/dc_crm_fe/attachment/jpg.png" />
                                                                                <img class="icon-img img-file" v-else-if="attachment.name.endsWith('.png')"
                                                                                    src="https://cdn.digicollect.com/cdn/dc_crm_fe/attachment/png-icon.svg" />
                                                                                <img class="icon-img img-file" v-else-if="attachment.name.endsWith('.gif')"
                                                                                    src="https://cdn.digicollect.com/cdn/dc_crm_fe/attachment/gif-icon.svg" />
                                                                                <img class="icon-img img-file" v-else-if="attachment.name.endsWith('.jpeg')"
                                                                                    src="https://cdn.digicollect.com/cdn/dc_crm_fe/attachment/jpg-icon.svg" />
                                                                                <img class="icon-img img-file" v-else-if="attachment.name.endsWith('.svg')"
                                                                                    src="https://cdn.digicollect.com/cdn/dc_crm_fe/attachment/svg-icon.svg" />
                                                                            </div> -->
                                                                        <div class="col">
                                                                            <!-- <div class="d-flex justify-content-between">
                                                                                <el-tooltip :content="attachment.name" placement="top">
                                                                                    <div
                                                                                        class="font-weight-bold text-truncate d-block mx-width-220">
                                                                                        {{attachment.name}}</div>
                                                                                </el-tooltip>
                                                                            </div>
                                                                            <div v-if="attachment.uploading || attachment.url == undefined">
                                                                                <progress-bar class="progressBar w-100"
                                                                                    :class="{'error-upload':attachment.url == undefined}"
                                                                                    :val="attachment.progress" size="small"></progress-bar>
                                                                            </div> -->
                                                                            <div class="d-flex justify-content-between">
                                                                                <div class="text-danger pl-0 fw-500"
                                                                                    v-if="attachment.error != ''">{{attachment.error}}
                                                                                </div>
                                                                                <div class="text-secondary fw-500"
                                                                                    v-if="attachment.progress<100 && attachment.error == ''">
                                                                                    Image {{attachment.progress}}% Uploaded</div>
                                                                                <!-- <div class="fw-500">({{attachment.size | prettyBytes}})
                                                                                </div> -->
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                </div>
                                                <div class="col-lg-6 col-md-6 col-sm-6">
                                                    <div class="mt-5 col-md-offset-2 flex-width">
                                                        <div class="stage-sections">
                                                            <span class="fw-500">Banner Image <sup class="fs-14 text-danger">*</sup></span>
                                                            <div class="overflow-auto mx-ht mt-3">
                                                                <div v-if="template_data.showBannerImageUpload" class="upload-main d-flex flex-column justify-content-center align-items-center pl-0 "
                                                                style="border: 3px dashed rgb(224, 224, 224);border-bottom-left-radius: 12px;border-bottom-right-radius: 12px;background-color: #fff;">
                                                                    <div id="drop_zone_outside" @drop="dropHandlerBanner($event, template_index)" @dragover="dragOverHandlerBanner($event)" class="img-upload px-3 px-sm-15 pt-3 pb-3 text-center bg-white">
                                                                        <span class="pr-4 hide-on-mob">Drag and Drop Files Here</span><br>
                                                                        <span class="pr-4 hide-on-mob" style="font-weight:400 !important;">or</span><br>
                                                                        <label class="choose-file mt-1 pointer">
                                                                            <img src="/static/images/multimedia.svg" style="width:20px;" alt="">
                                                                            <input type="file" id="upload_comment_file_upload_input_id" v-validate="'required'" :name="'banner_image'+template_index" @change="uploadBannerImage($event, template_index)" accept=".jpg, .png, .jpeg">
                                                                            Browse Files
                                                                        </label>
                                                                    </div>
                                                                    <div>
                                                                        <p class="drag_drop_cond text-center fs-14">
                                                                        Supports .jpg, .png, .jpeg Size limit - 5.00 MB
                                                                        </p>
                                                                    </div>
                                                                </div>
                                                                <div class="text-right mt-1">
                                                                    <span class="float-left text-danger mb-3" v-show="errors.has('banner_image'+template_index)">Banner Image is Required</span>
                                                                </div>
                                                                <div class="p-4" v-for="(attachment) in template_data.bannerImage"
                                                                    :key="attachment.url">
                                                                    <div class="overflow-auto mx-ht mt-3 d-flex justify-content-start align-items-top">
                                                                        <span v-if="attachment.progress == 100" class="_images pointer" style="position: relative;" @click="previewImage(attachment)">
                                                                            <img class="att-img pointer" :src="attachment.url" alt="">
                                                                        </span>
                                                                        <span v-else class="_images" style="position: relative;">
                                                                            <img class="att-img" :src="attachment.url" alt="">
                                                                        </span>
                                                                        <div>
                                                                            <div v-if="attachment.uploading || attachment.url == undefined"
                                                                                class="pointer mt-2" @click="deleteBannerImage(template_index)">
                                                                                <i class="icon icon-close fs-16 closeAttachment"></i>
                                                                            </div>
                                                                            <div v-else class="pointer mt-2" @click="deleteBannerImage(template_index)">
                                                                                <i class="icon icon-close fs-16 closeAttachment"></i>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                    <div class="d-flex align-items-center justify-content-between">
                                                                        <div class="d-flex align-items-center">
                                                                            <!-- <div>
                                                                                <img class="icon-img img-file" v-if="attachment.name.endsWith('.jpg')"
                                                                                    src="https://cdn.digicollect.com/cdn/dc_crm_fe/attachment/jpg.png" />
                                                                                <img class="icon-img img-file" v-else-if="attachment.name.endsWith('.png')"
                                                                                    src="https://cdn.digicollect.com/cdn/dc_crm_fe/attachment/png-icon.svg" />
                                                                                <img class="icon-img img-file" v-else-if="attachment.name.endsWith('.gif')"
                                                                                    src="https://cdn.digicollect.com/cdn/dc_crm_fe/attachment/gif-icon.svg" />
                                                                                <img class="icon-img img-file" v-else-if="attachment.name.endsWith('.jpeg')"
                                                                                    src="https://cdn.digicollect.com/cdn/dc_crm_fe/attachment/jpg-icon.svg" />
                                                                                <img class="icon-img img-file" v-else-if="attachment.name.endsWith('.svg')"
                                                                                    src="https://cdn.digicollect.com/cdn/dc_crm_fe/attachment/svg-icon.svg" />
                                                                            </div> -->
                                                                            <div class="col">
                                                                                <!-- <div class="d-flex justify-content-between">
                                                                                    <el-tooltip :content="attachment.name" placement="top">
                                                                                        <div
                                                                                            class="font-weight-bold text-truncate d-block mx-width-220">
                                                                                            {{attachment.name}}</div>
                                                                                    </el-tooltip>
                                                                                </div>
                                                                                <div v-if="attachment.uploading || attachment.url == undefined">
                                                                                    <progress-bar class="progressBar w-100"
                                                                                        :class="{'error-upload':attachment.url == undefined}"
                                                                                        :val="attachment.progress" size="small"></progress-bar>
                                                                                </div> -->
                                                                                <div class="d-flex justify-content-between">
                                                                                    <div class="text-danger pl-0 fw-500"
                                                                                        v-if="attachment.error != ''">{{attachment.error}}
                                                                                    </div>
                                                                                    <div class="text-secondary fw-500"
                                                                                        v-if="attachment.progress<100 && attachment.error == ''">
                                                                                        Image {{attachment.progress}}% Uploaded
                                                                                    </div>
                                                                                    <!-- <div class="fw-500">({{attachment.size | prettyBytes}})</div> -->
                                                                                </div>
                                                                            </div>
                                                                        </div>

                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div v-if="callDisable == false && isUploadingInProgress == false" class="mb-4 mt-2 add-another pointer" @click="AddNewContent()">
                                    <span class="">+Add Another content for different date or keep the same</span>
                                </div>
                            </div>
                            <div class="pt-3 px-17" >
                                <div class="create-company-header d-flex align-items-center justify-content-between">
                                    <span class="fs-14 text-white ml-1 fw-500">Attachments</span>
                                </div>
                                <div class="row">
                                    <div class="upload-main d-flex flex-column justify-content-center align-items-center attachment-bg pl-0 mt-8"
                                        :class="attachmentNew.length ? 'col-4' : 'col-12'"
                                        style="height: 18em;">
                                        <div
                                            class="d-flex justify-content-center align-items-center">
                                            <div class="mb-10">
                                                <img class="upload-img"
                                                    src="https://cdn.digicollect.com/cdn/dc_crm_fe/static/images/images/upload-icon.svg"><br>
                                                <span class="fs-14 fw-500 mt-2 mr-3">Drag and
                                                    Drop File or </span>
                                            </div>
                                            <file-upload
                                                :class="{'pointer-event':attachmentNew.length >= 10}"
                                                class="choose-file btn btn-new-primary mt-2"
                                                :multiple="true" :drop="true"
                                                :drop-directory="true"
                                                accept=".doc, .docx, .pdf, .ppt, .pptx, .txt, .Xls, .xlsx, .bmp, .jpeg, .png, .svg, .mpeg, .avi, .mp3, .mp4"
                                                @input-file="uploadAttachment($event)" ref="upload"
                                                style="text-transform: none !important">
                                                Browse
                                            </file-upload>
                                        </div>
                                        <span class="m-0 text-center">Supports .doc, .docx,
                                                .pdf, .ppt, .pptx, .txt, .Xls,</span>
                                        <span class="m-0 text-center">.xlsx, .bmp, .jpeg,
                                            .png, .svg, .avi, .mp3, .mpeg,
                                            .mp4</span>
                                        <p>Size limit- 25.00 MB (Max. 10 files)</p>
                                    </div>
                                    <div v-if="attachmentNew.length > 0"
                                        :class="attachmentNew.length ? 'col-8' : 'col-8'"
                                        style="height: 18em; overflow: auto;">
                                        <div class="attachmentsdiv p-4 my-2"
                                            v-for="(attachment,index) in attachmentNew"
                                            :key="index">
                                            <div
                                                class="d-flex align-items-center justify-content-between">
                                                <div class="d-flex align-items-center">
                                                    <div>
                                                        <img class="icon-img"
                                                            v-if="attachment.name.endsWith('.pdf')"
                                                            src="https://cdn.digicollect.com/cdn/dc_crm_fe/attachment/pdf-icon.svg" />
                                                        <img class="icon-img"
                                                            v-else-if="attachment.name.endsWith('.png')"
                                                            src="https://cdn.digicollect.com/cdn/dc_crm_fe/attachment/png-icon.svg" />
                                                        <img class="icon-img"
                                                            v-else-if="attachment.name.endsWith('.jpg')"
                                                            src="https://cdn.digicollect.com/cdn/dc_crm_fe/attachment/jpg.png" />
                                                        <img class="icon-img"
                                                            v-else-if="attachment.name.endsWith('.svg')"
                                                            src="https://cdn.digicollect.com/cdn/dc_crm_fe/attachment/svg-icon.svg" />
                                                        <img class="icon-img"
                                                            v-else-if="attachment.name.endsWith('.xls')"
                                                            src="https://cdn.digicollect.com/cdn/dc_crm_fe/attachment/xls-icon.svg" />
                                                        <img class="icon-img"
                                                            v-else-if="attachment.name.endsWith('.doc')"
                                                            src="https://cdn.digicollect.com/cdn/dc_crm_fe/attachment/doc-icon.svg" />
                                                        <img class="icon-img"
                                                            v-else-if="attachment.name.endsWith('.docx')"
                                                            src="https://cdn.digicollect.com/cdn/dc_crm_fe/attachment/docx-icon.svg" />
                                                        <!-- <img class="icon-img"
                                                            v-else-if="attachment.name.endsWith('.htm')"
                                                            src="https://cdn.digicollect.com/cdn/dc_crm_fe/attachment/htm-icon.svg" />
                                                        <img class="icon-img"
                                                            v-else-if="attachment.name.endsWith('.html')"
                                                            src="https://cdn.digicollect.com/cdn/dc_crm_fe/attachment/html-icon.svg" /> -->
                                                        <img class="icon-img"
                                                            v-else-if="attachment.name.endsWith('.ppt')"
                                                            src="https://cdn.digicollect.com/cdn/dc_crm_fe/attachment/ppt-icon.svg" />
                                                        <img class="icon-img"
                                                            v-else-if="attachment.name.endsWith('.pptx')"
                                                            src="https://cdn.digicollect.com/cdn/dc_crm_fe/attachment/pptx-icon.svg" />
                                                        <img class="icon-img"
                                                            v-else-if="attachment.name.endsWith('.txt')"
                                                            src="https://cdn.digicollect.com/cdn/dc_crm_fe/attachment/txt-icon.svg" />
                                                        <img class="icon-img"
                                                            v-else-if="attachment.name.endsWith('.xlsx')"
                                                            src="https://cdn.digicollect.com/cdn/dc_crm_fe/attachment/xlsx-icon.svg" />
                                                        <!-- <img class="icon-img"
                                                            v-else-if="attachment.name.endsWith('.bmp')"
                                                            src="https://cdn.digicollect.com/cdn/dc_crm_fe/attachment/bmp-icon.svg" />
                                                        <img class="icon-img"
                                                            v-else-if="attachment.name.endsWith('.gif')"
                                                            src="https://cdn.digicollect.com/cdn/dc_crm_fe/attachment/gif-icon.svg" /> -->
                                                        <img class="icon-img"
                                                            v-else-if="attachment.name.endsWith('.jpeg')"
                                                            src="https://cdn.digicollect.com/cdn/dc_crm_fe/attachment/jpg-icon.svg" />
                                                        <!-- <img class="icon-img"
                                                            v-else-if="attachment.name.endsWith('.tiff')"
                                                            src="https://cdn.digicollect.com/cdn/dc_crm_fe/attachment/jpg.png" /> -->
                                                        <img class="icon-img"
                                                            v-else-if="attachment.name.endsWith('.avi')"
                                                            src="https://cdn.digicollect.com/cdn/dc_crm_fe/attachment/avi-icon.svg" />
                                                        <!-- <img class="icon-img"
                                                            v-else-if="attachment.name.endsWith('.flv')"
                                                            src="https://cdn.digicollect.com/cdn/dc_crm_fe/attachment/flv-icon.svg" />
                                                        <img class="icon-img"
                                                            v-else-if="attachment.name.endsWith('.mpg')"
                                                            src="https://cdn.digicollect.com/cdn/dc_crm_fe/attachment/mpg-icon.svg" /> -->
                                                        <img class="icon-img"
                                                            v-else-if="attachment.name.endsWith('.mpeg')"
                                                            src="https://cdn.digicollect.com/cdn/dc_crm_fe/attachment/mpeg-icon.svg" />
                                                        <img class="icon-img"
                                                            v-else-if="attachment.name.endsWith('.mp3')"
                                                            src="https://cdn.digicollect.com/cdn/dc_crm_fe/attachment/mp3-icon.svg" />
                                                        <img class="icon-img"
                                                            v-else-if="attachment.name.endsWith('.mp4')"
                                                            src="https://cdn.digicollect.com/cdn/dc_crm_fe/attachment/mp4-icon.svg" />
                                                        <!-- <img class="icon-img"
                                                            v-else-if="attachment.name.endsWith('.wav')"
                                                            src="https://cdn.digicollect.com/cdn/dc_crm_fe/attachment/wav-icon.svg" />
                                                        <img class="icon-img"
                                                            v-else-if="attachment.name.endsWith('.wmv')"
                                                            src="https://cdn.digicollect.com/cdn/dc_crm_fe/attachment/wmv-icon.svg" /> -->
                                                    </div>
                                                    <div class="col">
                                                        <div
                                                            class="d-flex justify-content-between">
                                                            <el-tooltip
                                                                :content="attachment.name"
                                                                placement="top">
                                                                <div
                                                                    class="font-weight-bold text-truncate d-block mx-width-220">
                                                                    {{attachment.name}}</div>
                                                            </el-tooltip>
                                                        </div>
                                                        <div
                                                            v-if="attachment.uploading || attachment.url == undefined">
                                                            <progress-bar
                                                                class="progressBar w-100"
                                                                :class="{'error-upload':attachment.url == undefined}"
                                                                :val="attachment.progress"
                                                                size="small"></progress-bar>
                                                        </div>
                                                        <div
                                                            class="d-flex justify-content-between">
                                                            <div class="text-danger pl-0 fw-500"
                                                                v-if="attachment.error != ''">
                                                                {{attachment.error}}...</div>
                                                            <div class="text-secondary fw-500"
                                                                v-if="attachment.progress<100 && attachment.error == ''">
                                                                {{attachment.progress}}%
                                                                Uploading</div>
                                                            <div class="text-secondary fw-500"
                                                                v-if="attachment.progress==100 && attachment.error == ''">
                                                                {{attachment.progress}}%
                                                                Uploaded</div>
                                                            <div class="fw-500">
                                                                ({{attachment.size | prettyBytes}})
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div v-if="attachment.uploading || attachment.url == undefined"
                                                    class="pointer"
                                                    @click="deleteAttachment(attachment, index)">
                                                    <i
                                                        class="icon icon-close fs-16 closeAttachment"></i>
                                                </div>
                                                <div v-else class="pointer"
                                                    @click="deleteAttachment(attachment, index)">
                                                    <i
                                                        class="icon icon-close fs-16 closeAttachment"></i>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <!-- <email-template-one v-if="createJson.selectedtemplate === 'template1'"></email-template-one>
                            <email-template-two v-if="createJson.selectedtemplate === 'template2'"></email-template-two>
                            <email-template-three v-if="createJson.selectedtemplate === 'template3'"></email-template-three> -->
                            <div class="d-flex flex-wrap align-items-center justify-content-center mb-4 mt-5">
                                <button class="btn new-cancel-button" @click="gotoListView()">Cancel</button>
                                <button class="btn btn-new-save fw-600 fs-14 ml-5" :disabled="isUploadingInProgress" @click="saveCampaign">Preview</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <add-new-content v-if="add_new_content" modal_name="add_new_content" @hideAddNewContent="hideAddNewContent"></add-new-content>
        <preview @hidePreview="hidePreview" v-if="preview_visible" :file_preview="preview_file"></preview>
        <contacts-modal v-if="openContactsPopUp" :selectContacts="this.createJson.recipient_details" @selectedContacts="selectedContacts" modal_name="contactsPopUp" @hide-contacts-modal="closeContactsModal()"></contacts-modal>
        <broadcast-alert-modal v-if="showBroadcastAlertModal" @hideBroadcastAlertModal="hideBroadcastAlertModal" modal_name="BroadcastAlertModal" @confirmBroadcastSelect="confirmBroadcastSelect"></broadcast-alert-modal>
        <start-date-alert-modal v-if="showStartDateAlertModal" @hideStartDateAlertModal="hideStartDateAlertModal" modal_name="StartDateAlertModal" @confirmStartDateChange="confirmStartDateChange"></start-date-alert-modal>
        <end-date-alert-modal v-if="showEndDateAlertModal" @hideEndDateAlertModal="hideEndDateAlertModal" modal_name="EndDateAlertModal" @confirmEndDateChange="confirmEndDateChange"></end-date-alert-modal>
    </div>
</template>
<script>
import VueTagsInput from "@johmun/vue-tags-input";
import AddNewContent from './AddNewContent'
import moment from 'moment';
var mime = require('mime-types')
const Preview = () => import("../../Preview");
import countries from "../../json/countries.json";
import axios from "axios";
import customer from "../../mixins/customer"
import leads from "../../mixins/leads"
import campaign from "../../mixins/campaign"
// import { EventBus } from './eventBus/nav-bar-event';
import EmailTemplateOne from './EmailTemplateOne';
import { HalfCircleSpinner } from "epic-spinners";
import EmailTemplateTwo from './EmailTemplateTwo';
import EmailTemplateThree from './EmailTemplateThree';
import BroadcastAlertModal from './BroadcastAlertModal';
import StartDateAlertModal from './StartDateAlertModal';
import EndDateAlertModal from './EndDateAlertModal';
import { EventBus } from '../../eventBus/nav-bar-event';
const ContactsModal = () => import("./ContactsModal");
export default {
    name: "InputUrl",
    data(){
        return {
            email_regex: /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,50})+$/,
            invalidEmail: false,
            tags: [],
            tag: "",
            maxTags: 10,
            pre_start_date: '',
            pre_end_date: '',
            selected_temp_start_date: '',
            selected_temp_end_date: '',
            showStartDateAlertModal: false,
            showEndDateAlertModal: false,
            disable_broadcast: false,
            temp_broadcast_value: "",
            showBroadcastAlertModal: false,
            callDisable: true,
            ajaxCallLoadContentDetails: false,
            location_index: 0,
            add_new_content: false,
            bindProps: {
                mode: "international",
                defaultCountry: "US"
            },
            // phone_number: {
            //     number: "",
            //     code: ""
            // },
            // showLogoImageUpload: true,
            // showBannerImageUpload: true,
            isUploadingInProgress: false,
            openContactsPopUp: false,
            createJson:{
                author_name: "",
                author_email: "",
                campaign_name: "",
                campaign_type: "Email",
                //industry_type: "",
                start_time: "",
                start_date: moment(new Date().toUTCString()).format("YYYY-MM-DD"),
                // start_time: moment(new Date().toUTCString()).format("HH:mm"),
                end_date: "",
                //end_time: "",
                recurrence_days: "Once",
                currency: "",
                budget: "",
                send_now: false,
                selectedtemplate: "",
                description: "",
                recipient_details: [],
                is_customized: false,
                // topic_name: "",
                // headline_url: "",
                // add_url: "",
                // headline: "",
                // content: "",
                // address: "",
                // state: "",
                // city: "",
                // township: "",
                // zip_code: "",
                // facebook_url: "",
                // twitter_url: "",
                // insta_url: "",
                // linkedin_url: "",
            },
            template_details:[{
                template_dates: [],
                topic_name: "",
                headline_url: "",
                add_url: "",
                headline: "",
                content: "",
                phone_number: {
                    number: "",
                    code: "",
                    country_code: ""
                },
                meeting_location_vmodel: "",
                location:{
                    address_type: "mailing_address",
                    building_number: "",
                    street:'',
                    city:'',
                    township:'',
                    state:'',
                    country:'',
                    zip_code:'',
                    latitude:'',
                    longitude:'',
                },
                facebook_url: "",
                twitter_url: "",
                insta_url: "",
                linkedin_url: "",
                logoImage: [],
                bannerImage: [],
                showLogoImageUpload: true,
                showBannerImageUpload: true,
                content_radio: 'new0',
                copy_content: '',
            }],
            attachmentNew:[],
            // logoImage: [],
            // bannerImage: [],
            countries: countries,
            // location:{
            //     full_address: "",
            //     address_type: "mailing_address",
            //     street:'',
            //     city:'',
            //     township:'',
            //     country:'',
            //     zip_code:'',
            //     latitude:'',
            //     longitude:'',
            // },
            // meeting_location_vmodel: "",
            ajaxCallInProgress: false,
            recipientsLoading: false,
            // industries: ["Accommodation and Food Services",
            //     "Administrative and Support, Waste Management and Remediation Services",
            //     "Agriculture, Forestry, Fishing and Hunting", "Arts, Entertainment and Recreation",
            //     "Construction", "Developer", "Educational Services", "EPC", "Finance and Insurance", "F&B",
            //     "Health Care and Social Assistance", "Information and Cultural Industries",
            //     "Management of Companies and Enterprises", "Manufacturing",
            //     "Mining, Quarrying, and Oil and Gast Extraction",
            //     "Other Services (except public administration)",
            //     "Professional, Scientific and Technical Services", "Public Administration",
            //     "Real Estate and Rental and Leasing", "Residential Installation", "Retail Trade", "Supplier",
            //     "Transportation and Warehousing",
            //     "Utilities", "Wholesale Trade", "Other Businesses"
            // ],
            is_start_date: false,
            is_start_time: false,
            is_end_time:false,
            is_end_date: false,
            recurrencedays: ["Once", "Daily", "Weekly", "Monthly"],
            recurrence_nos: null,
            //recurrencenumbers: ["None", "Once", "Twice", "Thrice", "Every 4 hours", "Morning", "Evening"],
            search_term: "",
            optionsRecipients: [],
            optionsRecipientsEmpty: [],
            isLoading: false,
            scrollableCustomer: false,
            limit: 10,
            search_term: "",
            search_key: "",
            total: 0,
            skip: 0,
            skip_count: 0,
            count: 0,
            isVisible: false,
            show_temp_data:false,
            selectedtemplate: null,
            preview_file: '',
            preview_visible: false,
            campaign_details: [],
            campaign_id: "",
            // url: "",
            // isValid: false,
            // regex: [-a-zA-Z0-9@:%_+.~#?&//=]{2,256}(.[a-z]{2,4})?\b(/[-a-zA-Z0-9@:%_+.~#?&//=]*)?,
            image: {
                //url1: '/static/images/template-one-image.png',
                //url2: '/static/images/template-two-image.png',
                name: "template3.png",
                url: '/static/images/template3.webp',
            },
            start_date_time_format: [
                '00:00',
                '00:15',
                '00:30',
                '00:45',
                '01:00',
                '01:15',
                '01:30',
                '01:45',
                '02:00',
                '02:15',
                '02:30',
                '02:45',
                '03:00',
                '03:15',
                '03:30',
                '03:45',
                '04:00',
                '04:15',
                '04:30',
                '04:45',
                '05:00',
                '05:15',
                '05:30',
                '05:45',
                '06:00',
                '06:15',
                '06:30',
                '06:45',
                '07:00',
                '07:15',
                '07:30',
                '07:45',
                '08:00',
                '08:15',
                '08:30',
                '08:45',
                '09:00',
                '09:15',
                '09:30',
                '09:45',
                '10:00',
                '10:15',
                '10:30',
                '10:45',
                '11:00',
                '11:15',
                '11:30',
                '11:45',
                '12:00',
                '12:15',
                '12:30',
                '12:45',
                '13:00',
                '13:15',
                '13:30',
                '13:45',
                '14:00',
                '14:15',
                '14:30',
                '14:45',
                '15:00',
                '15:15',
                '15:30',
                '15:45',
                '16:00',
                '16:15',
                '16:30',
                '16:45',
                '17:00',
                '17:15',
                '17:30',
                '17:45',
                '18:00',
                '18:15',
                '18:30',
                '18:45',
                '19:00',
                '19:15',
                '19:30',
                '19:45',
                '20:00',
                '20:15',
                '20:30',
                '20:45',
                '21:00',
                '21:15',
                '21:30',
                '21:45',
                '22:00',
                '22:15',
                '22:30',
                '22:45',
                '23:00',
                '23:15',
                '23:30',
                '23:45',
            ],
            end_date_time_format:[
                '00:00',
                '00:15',
                '00:30',
                '00:45',
                '01:00',
                '01:15',
                '01:30',
                '01:45',
                '02:00',
                '02:15',
                '02:30',
                '02:45',
                '03:00',
                '03:15',
                '03:30',
                '03:45',
                '04:00',
                '04:15',
                '04:30',
                '04:45',
                '05:00',
                '05:15',
                '05:30',
                '05:45',
                '06:00',
                '06:15',
                '06:30',
                '06:45',
                '07:00',
                '07:15',
                '07:30',
                '07:45',
                '08:00',
                '08:15',
                '08:30',
                '08:45',
                '09:00',
                '09:15',
                '09:30',
                '09:45',
                '10:00',
                '10:15',
                '10:30',
                '10:45',
                '11:00',
                '11:15',
                '11:30',
                '11:45',
                '12:00',
                '12:15',
                '12:30',
                '12:45',
                '13:00',
                '13:15',
                '13:30',
                '13:45',
                '14:00',
                '14:15',
                '14:30',
                '14:45',
                '15:00',
                '15:15',
                '15:30',
                '15:45',
                '16:00',
                '16:15',
                '16:30',
                '16:45',
                '17:00',
                '17:15',
                '17:30',
                '17:45',
                '18:00',
                '18:15',
                '18:30',
                '18:45',
                '19:00',
                '19:15',
                '19:30',
                '19:45',
                '20:00',
                '20:15',
                '20:30',
                '20:45',
                '21:00',
                '21:15',
                '21:30',
                '21:45',
                '22:00',
                '22:15',
                '22:30',
                '22:45',
                '23:00',
                '23:15',
                '23:30',
                '23:45',
            ],
            nameFacebook: "facebook_url_regex",
            urlFacebook: "",
            isValidFacebook: true,
            regexFacebook: /^http(s*):\/\/(www.)*facebook\.com\/[a-zA-Z0-9._]+$/i,
            nameTwitter: "twitter_url_regex",
            urlTwitter: "",
            isValidTwitter: true,
            regexTwitter: /^http(s*):\/\/(www.)*twitter\.com\/[a-zA-Z0-9._]+$/i,
            nameInstagram: "instagram_url_regex",
            urlInstagram: "",
            isValidInstagram: true,
            regexInstagram: /^http(s*):\/\/(www.)*instagram\.com\/[a-zA-Z0-9._]+$/i,
            nameLinkedin: "linkedin_url_regex",
            urlLinkedin: "",
            isValidLinkedin: true,
            regexLinkedin:  /^http(s*):\/\/(www.)*linkedin\.com\/[a-zA-Z0-9._]+$/i,
            // selected_all_in_receipts_popup: {
            //     contact: false,
            //     customer: false,
            //     lead: false,
            // }
            validation: [{
                classes: 'avoid-item',
                rule: /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,50})+$/,
                disableAdd: true,
            }],
            email_duplicated: '',
            total_file_size: 0,
        }
    },
    mixins: [customer,leads,campaign],
    components:{
        EmailTemplateOne,
        EmailTemplateTwo,
        EmailTemplateThree,
        Preview,
        HalfCircleSpinner,
        ContactsModal,
        AddNewContent,
        BroadcastAlertModal,
        StartDateAlertModal,
        EndDateAlertModal,
        VueTagsInput
    },
    methods:{
        deleteAttachment(attachment, index) {
            this.total_file_size = this.total_file_size - attachment.size
            this.attachmentNew.splice(index, 1);
            //document.getElementById("multiple").value = "";
            if (attachment.url == undefined) {
                this.check_attachments = false;
            }
        },
        uploadAttachment(newFile) {
            var input = newFile;
            this.total_file_size = this.total_file_size + input.file.size
            if(this.attachmentNew.map(x => x.name).includes(input.file.name)){
                this.$toasted.global.error("This file already exists")
            } else if(!input.file.name.endsWith('.htm') && !input.file.name.endsWith('.html') && !input.file.name.endsWith('.flv')){
                if (input.file) {
                    const CancelToken = axios.CancelToken;
                    const source = CancelToken.source();
                    /**@params = name, @params = size,@params = source, @params = progress, @params = error */
                    let attachment = {
                        name: input.file.name,
                        size: JSON.stringify(input.file.size),
                        source: source,
                        progress: 0,
                        created_time: new Date(),
                        error: ""
                    }
                    if (this.attachmentNew.length >= 10) {
                        this.$toasted.global.error("you're not allowed to upload more than 10 attachments")
                        this.total_file_size = this.total_file_size - input.file.size
                    } else if (this.total_file_size > 25000 * 1000) {
                        this.$toasted.global.error("Attachments Size Cannot Exceed 25mb")
                        this.total_file_size = this.total_file_size - input.file.size
                    } else {
                        this.attachmentNew.push(attachment);
                        this.getResumableURLAtt(input.file, this.attachmentNew[this.attachmentNew.length - 1]);
                        // this.getResumableURL(input.file, this.template_details[index].attachments[this.template_details[index].attachments.length - 1]);
                    }
                }
            } else {
                this.$toasted.global.error("This file is not supported")
            }
        },
        getResumableURLAtt(file, attachment) {
            this.isUploadingInProgress = true;
            // this.template_details[index].attachments = false;
            attachment.uploading = true;
            let usage_type = {
                usage: "attachment"
            }
            let data = {
                file: attachment.name
            }
            data = new FormData()
            data.append('file',file)
            Object.keys(usage_type).map(e => {
                data.append(e, JSON.stringify(usage_type[e]))
            })
            this.$http.post('https://cloudapis.digicollect.com/external/upload_file', data,{
                onUploadProgress: function (progressEvent) {
                    let progress = parseInt(Math.round((progressEvent.loaded * 100) / progressEvent.total));
                    if (progress < 100) {
                        attachment.progress = progress;
                    }
                }.bind(this)
            })
            .then(response => {
                let resumable_url = response.data.url;
                attachment.url = resumable_url;
                attachment.progress = 100;
                attachment.uploading = false;
                this.isUploadingInProgress = false;
                // this.template_details[index].attachments = false;
                delete attachment['source'];
            })
            .catch(error => {

            })
        },
        prefetchURL(index, event){
            if(this.template_details[index].add_url.length == 1){
                this.template_details[index].add_url = "https://www." + event.target.value
            }
        },
        sendNowChanged(event){
            if(event.target.checked === true){
                this.createJson.start_time = ""
            }
        },
        //Selects broadcast and updates date fields
        selectBroadcast(value){
            if(value == 'Once'){
                if(this.template_details.length > 1){
                    this.showBroadcastAlertModal = true;
                    setTimeout(() => {
                        this.$modal.show("BroadcastAlertModal");
                    }, 500);
                } else{
                    this.callDisable = true;
                    this.createJson.end_date = ""
                    this.createJson.start_time = ""
                }
            } else {
                this.temp_broadcast_value = value
                this.callDisable = false;
                this.createJson.send_now = false;
            }
        },
        hideBroadcastAlertModal(){
            this.createJson.recurrence_days = this.temp_broadcast_value
            this.showBroadcastAlertModal = false;
        },
        hideStartDateAlertModal(){
            this.createJson.start_date =  this.pre_start_date;
            this.showStartDateAlertModal = false;
        },
        //When start date changes single campaign will be created
        confirmStartDateChange(){
            let temp_template_dates = []
            this.template_details = []
            this.pre_start_date = this.selected_temp_start_date
            this.createJson.start_date = this.selected_temp_start_date
            //this.template_details[0].template_dates = []
            this.createJson.end_date = ''
            temp_template_dates.push(this.createJson.start_date)
            this.disablePreTime();
            this.template_details.push({
                template_dates: temp_template_dates,
                topic_name: "",
                headline_url: "",
                add_url: "",
                headline: "",
                content: "",
                phone_number: {
                    number: "",
                    code: "",
                    country_code:""
                },
                meeting_location_vmodel: "",
                location:{
                    address_type: "mailing_address",
                    building_number: "",
                    street:'',
                    city:'',
                    township:'',
                    state:'',
                    country:'',
                    zip_code:'',
                    latitude:'',
                    longitude:'',
                },
                facebook_url: "",
                twitter_url: "",
                insta_url: "",
                linkedin_url: "",
                logoImage: [],
                bannerImage: [],
                showLogoImageUpload: true,
                showBannerImageUpload: true,
                content_radio: 'new0',
                copy_content: '',
            })
            this.hideStartDateAlertModal();
        },
        //When end date changes single campaign will be created
        confirmEndDateChange(){
            let temp_template_dates = []
            this.template_details = []
            this.pre_end_date = this.selected_temp_end_date
            this.createJson.end_date = this.selected_temp_end_date
            temp_template_dates.push(this.createJson.start_date)
            this.template_details.push({
                template_dates: temp_template_dates,
                topic_name: "",
                headline_url: "",
                add_url: "",
                headline: "",
                content: "",
                phone_number: {
                    number: "",
                    code: "",
                    country_code:""
                },
                meeting_location_vmodel: "",
                location:{
                    address_type: "mailing_address",
                    building_number: "",
                    street:'',
                    city:'',
                    township:'',
                    state:'',
                    country:'',
                    zip_code:'',
                    latitude:'',
                    longitude:'',
                },
                facebook_url: "",
                twitter_url: "",
                insta_url: "",
                linkedin_url: "",
                logoImage: [],
                bannerImage: [],
                showLogoImageUpload: true,
                showBannerImageUpload: true,
                content_radio: 'new0',
                copy_content: '',
            })
            this.hideEndDateAlertModal();
        },
        //When broadcast value changes single campaign will be created
        confirmBroadcastSelect(){
            let temp_template_dates = []
            temp_template_dates.push(this.createJson.start_date)
            this.showBroadcastAlertModal = false;
            this.temp_broadcast_value = "Once"
            this.template_details = []
            this.callDisable = true;
            this.createJson.end_date = ""
            this.createJson.start_time = ""
            this.template_details.push({
                template_dates: temp_template_dates,
                topic_name: "",
                headline_url: "",
                add_url: "",
                headline: "",
                content: "",
                phone_number: {
                    number: "",
                    code: "",
                    country_code:""
                },
                meeting_location_vmodel: "",
                location:{
                    address_type: "mailing_address",
                    building_number: "",
                    street:'',
                    city:'',
                    township:'',
                    state:'',
                    country:'',
                    zip_code:'',
                    latitude:'',
                    longitude:'',
                },
                facebook_url: "",
                twitter_url: "",
                insta_url: "",
                linkedin_url: "",
                logoImage: [],
                bannerImage: [],
                showLogoImageUpload: true,
                showBannerImageUpload: true,
                content_radio: 'new0',
                copy_content: '',
            })
        },
        //Opens add multiple campaigns popup
        AddNewContent() {
            this.add_new_content = true
            localStorage.setItem('add_new_content', JSON.stringify(this.createMainJsonData))
            setTimeout(() => {
                this.$modal.show("add_new_content");
            }, 500);
        },
        hideAddNewContent() {
            this.add_new_content = false
        },
        campaignPhoneInput(index, evt,number,isValid,country) {
            this.template_details[index].phone_number.code = '+'+evt.country.dialCode
            this.template_details[index].phone_number.country_code = evt.country.iso2
            this.template_details[index].phone_number.number = evt.number.significant ? evt.number.significant : ""
        },
        evaluvateData(){
            if(this.createJson.budget.startsWith(".")){
                this.createJson.budget = "0."
            }
        },
        //Checks enterd data is number or not
        isNumber: (evt) =>  {
            var charCode = (evt.which) ? evt.which : evt.keyCode
            if (charCode > 31 && (charCode < 48 || charCode > 57) && !(charCode == 46 || charCode == 8))
                evt.preventDefault();
            else {
                var index = evt.target.value.indexOf('.');
                if(index == 0){
                    if (charCode > 31 && (charCode < 48 || charCode > 57) && !(charCode == 8)){
                        evt.preventDefault();
                    } else {
                        let number = evt.target.value.split('.')
                        if(number[1].length > 1){
                            evt.preventDefault();
                        }
                    }
                }
                else if (index > 0 && charCode == 46) {
                    evt.preventDefault();
                }
                if (index > 0) {
                    let number = evt.target.value.split('.')
                    if(number[1].length > 1){
                        evt.preventDefault();
                    }
                }
            }
        },
        //Validates time to show future time
        CheckDate(){
            if(this.createJson.start_date == this.createJson.end_date){
                var temp_start_date = ""
                if(parseInt(this.createJson.start_time.substring(3)) >= 0 && parseInt(this.createJson.start_time.substring(3)) < 15){
                    temp_start_date = this.createJson.start_time.slice(0,3) + '00'
                } else if(parseInt(this.createJson.start_time.substring(3)) >= 15 && parseInt(this.createJson.start_time.substring(3)) < 30){
                    temp_start_date = this.createJson.start_time.slice(0,3) + '15'
                } else if(parseInt(this.createJson.start_time.substring(3)) >= 30 && parseInt(this.createJson.start_time.substring(3)) < 45){
                    temp_start_date = this.createJson.start_time.slice(0,3) + '30'
                } else if(parseInt(this.createJson.start_time.substring(3)) >= 45){
                    temp_start_date = this.createJson.start_time.slice(0,3) + '45'
                }
                this.end_date_time_format = [
                    '00:00',
                    '00:15',
                    '00:30',
                    '00:45',
                    '01:00',
                    '01:15',
                    '01:30',
                    '01:45',
                    '02:00',
                    '02:15',
                    '02:30',
                    '02:45',
                    '03:00',
                    '03:15',
                    '03:30',
                    '03:45',
                    '04:00',
                    '04:15',
                    '04:30',
                    '04:45',
                    '05:00',
                    '05:15',
                    '05:30',
                    '05:45',
                    '06:00',
                    '06:15',
                    '06:30',
                    '06:45',
                    '07:00',
                    '07:15',
                    '07:30',
                    '07:45',
                    '08:00',
                    '08:15',
                    '08:30',
                    '08:45',
                    '09:00',
                    '09:15',
                    '09:30',
                    '09:45',
                    '10:00',
                    '10:15',
                    '10:30',
                    '10:45',
                    '11:00',
                    '11:15',
                    '11:30',
                    '11:45',
                    '12:00',
                    '12:15',
                    '12:30',
                    '12:45',
                    '13:00',
                    '13:15',
                    '13:30',
                    '13:45',
                    '14:00',
                    '14:15',
                    '14:30',
                    '14:45',
                    '15:00',
                    '15:15',
                    '15:30',
                    '15:45',
                    '16:00',
                    '16:15',
                    '16:30',
                    '16:45',
                    '17:00',
                    '17:15',
                    '17:30',
                    '17:45',
                    '18:00',
                    '18:15',
                    '18:30',
                    '18:45',
                    '19:00',
                    '19:15',
                    '19:30',
                    '19:45',
                    '20:00',
                    '20:15',
                    '20:30',
                    '20:45',
                    '21:00',
                    '21:15',
                    '21:30',
                    '21:45',
                    '22:00',
                    '22:15',
                    '22:30',
                    '22:45',
                    '23:00',
                    '23:15',
                    '23:30',
                    '23:45',
                ]
                let indx = this.end_date_time_format.indexOf(temp_start_date)
                this.end_date_time_format.splice(0,indx+1)
            } else {
                this.end_date_time_format = [
                    '00:00',
                    '00:15',
                    '00:30',
                    '00:45',
                    '01:00',
                    '01:15',
                    '01:30',
                    '01:45',
                    '02:00',
                    '02:15',
                    '02:30',
                    '02:45',
                    '03:00',
                    '03:15',
                    '03:30',
                    '03:45',
                    '04:00',
                    '04:15',
                    '04:30',
                    '04:45',
                    '05:00',
                    '05:15',
                    '05:30',
                    '05:45',
                    '06:00',
                    '06:15',
                    '06:30',
                    '06:45',
                    '07:00',
                    '07:15',
                    '07:30',
                    '07:45',
                    '08:00',
                    '08:15',
                    '08:30',
                    '08:45',
                    '09:00',
                    '09:15',
                    '09:30',
                    '09:45',
                    '10:00',
                    '10:15',
                    '10:30',
                    '10:45',
                    '11:00',
                    '11:15',
                    '11:30',
                    '11:45',
                    '12:00',
                    '12:15',
                    '12:30',
                    '12:45',
                    '13:00',
                    '13:15',
                    '13:30',
                    '13:45',
                    '14:00',
                    '14:15',
                    '14:30',
                    '14:45',
                    '15:00',
                    '15:15',
                    '15:30',
                    '15:45',
                    '16:00',
                    '16:15',
                    '16:30',
                    '16:45',
                    '17:00',
                    '17:15',
                    '17:30',
                    '17:45',
                    '18:00',
                    '18:15',
                    '18:30',
                    '18:45',
                    '19:00',
                    '19:15',
                    '19:30',
                    '19:45',
                    '20:00',
                    '20:15',
                    '20:30',
                    '20:45',
                    '21:00',
                    '21:15',
                    '21:30',
                    '21:45',
                    '22:00',
                    '22:15',
                    '22:30',
                    '22:45',
                    '23:00',
                    '23:15',
                    '23:30',
                    '23:45',
                ]
            }
        },
        //To check social media URL formats
        changeFacebook:function(e){
            const urlFacebook = e.target.value
            this.isURLValidFacebook(urlFacebook);
        },
        changeTwitter:function(e){
            const urlTwitter = e.target.value
            this.isURLValidTwitter(urlTwitter);
        },
        changeInstagram:function(e){
            const urlInstagram = e.target.value
            this.isURLValidInstagram(urlInstagram);
        },
        changeLinkedin:function(e){
            const urlLinkedin = e.target.value
            this.isURLValidLinkedin(urlLinkedin);
        },
        isURLValidFacebook(facebook_url_regex) {
            this.isValidFacebook = this.regexFacebook.test(facebook_url_regex)
        },
        isURLValidTwitter(twitter_url_regex) {
            this.isValidTwitter = this.regexTwitter.test(twitter_url_regex)
        },
        isURLValidInstagram(instagram_url_regex) {
            this.isValidInstagram = this.regexInstagram.test(instagram_url_regex)
        },
        isURLValidLinkedin(linkedin_url_regex) {
            this.isValidLinkedin = this.regexLinkedin.test(linkedin_url_regex)
        },
        gotoListView(){
            this.$router.push({
                path: '/campaign/email/campaignEmailListView/'
            })
        },
        removeTag(tag){
            this.createJson.recipient_details.forEach((el,index)=>{
                if(el.id == tag.id){
                    this.createJson.recipient_details.splice(index,1)
                }
            })
        },
        selectedContacts(selected_contacts){
            this.recipientsLoading = true;
            this.createJson.recipient_details = []
            // this.selected_all_in_receipts_popup = selected_contacts.selected_all
            selected_contacts.forEach((el, el_index)=>{
                this.createJson.recipient_details.push(el)
            })
            setTimeout(() => {
                this.recipientsLoading = false;
            }, 1000);
        },
        contactsPop(){
            this.openContactsPopUp = true;
            setTimeout(()=>{
                this.$modal.show("contactsPopUp")
            },500)
        },
        closeContactsModal(){
            this.openContactsPopUp = false;
        },
        //Validates time to show future time
        disablePreTime(){
            var curr_date = moment(new Date().toUTCString()).format("YYYY-MM-DD")
            if(this.createJson.start_date != curr_date){
                this.start_date_time_format = [
                    '00:00',
                    '00:15',
                    '00:30',
                    '00:45',
                    '01:00',
                    '01:15',
                    '01:30',
                    '01:45',
                    '02:00',
                    '02:15',
                    '02:30',
                    '02:45',
                    '03:00',
                    '03:15',
                    '03:30',
                    '03:45',
                    '04:00',
                    '04:15',
                    '04:30',
                    '04:45',
                    '05:00',
                    '05:15',
                    '05:30',
                    '05:45',
                    '06:00',
                    '06:15',
                    '06:30',
                    '06:45',
                    '07:00',
                    '07:15',
                    '07:30',
                    '07:45',
                    '08:00',
                    '08:15',
                    '08:30',
                    '08:45',
                    '09:00',
                    '09:15',
                    '09:30',
                    '09:45',
                    '10:00',
                    '10:15',
                    '10:30',
                    '10:45',
                    '11:00',
                    '11:15',
                    '11:30',
                    '11:45',
                    '12:00',
                    '12:15',
                    '12:30',
                    '12:45',
                    '13:00',
                    '13:15',
                    '13:30',
                    '13:45',
                    '14:00',
                    '14:15',
                    '14:30',
                    '14:45',
                    '15:00',
                    '15:15',
                    '15:30',
                    '15:45',
                    '16:00',
                    '16:15',
                    '16:30',
                    '16:45',
                    '17:00',
                    '17:15',
                    '17:30',
                    '17:45',
                    '18:00',
                    '18:15',
                    '18:30',
                    '18:45',
                    '19:00',
                    '19:15',
                    '19:30',
                    '19:45',
                    '20:00',
                    '20:15',
                    '20:30',
                    '20:45',
                    '21:00',
                    '21:15',
                    '21:30',
                    '21:45',
                    '22:00',
                    '22:15',
                    '22:30',
                    '22:45',
                    '23:00',
                    '23:15',
                    '23:30',
                    '23:45',
                ]
            }
            else {
                var temp_start_time = ""
                var curr_time = moment(new Date().toUTCString()).format("HH:mm");
                if(parseInt(curr_time.substring(3)) >= 0 && parseInt(curr_time.substring(3)) < 15){
                    temp_start_time = curr_time.slice(0,3) + '00'
                } else if(parseInt(curr_time.substring(3)) >= 15 && parseInt(curr_time.substring(3)) < 30){
                    temp_start_time = curr_time.slice(0,3) + '15'
                } else if(parseInt(curr_time.substring(3)) >= 30 && parseInt(curr_time.substring(3)) < 45){
                    temp_start_time = curr_time.slice(0,3) + '30'
                } else if(parseInt(curr_time.substring(3)) >= 45){
                    temp_start_time = curr_time.slice(0,3) + '45'
                }
                this.start_date_time_format = [
                    '00:00',
                    '00:15',
                    '00:30',
                    '00:45',
                    '01:00',
                    '01:15',
                    '01:30',
                    '01:45',
                    '02:00',
                    '02:15',
                    '02:30',
                    '02:45',
                    '03:00',
                    '03:15',
                    '03:30',
                    '03:45',
                    '04:00',
                    '04:15',
                    '04:30',
                    '04:45',
                    '05:00',
                    '05:15',
                    '05:30',
                    '05:45',
                    '06:00',
                    '06:15',
                    '06:30',
                    '06:45',
                    '07:00',
                    '07:15',
                    '07:30',
                    '07:45',
                    '08:00',
                    '08:15',
                    '08:30',
                    '08:45',
                    '09:00',
                    '09:15',
                    '09:30',
                    '09:45',
                    '10:00',
                    '10:15',
                    '10:30',
                    '10:45',
                    '11:00',
                    '11:15',
                    '11:30',
                    '11:45',
                    '12:00',
                    '12:15',
                    '12:30',
                    '12:45',
                    '13:00',
                    '13:15',
                    '13:30',
                    '13:45',
                    '14:00',
                    '14:15',
                    '14:30',
                    '14:45',
                    '15:00',
                    '15:15',
                    '15:30',
                    '15:45',
                    '16:00',
                    '16:15',
                    '16:30',
                    '16:45',
                    '17:00',
                    '17:15',
                    '17:30',
                    '17:45',
                    '18:00',
                    '18:15',
                    '18:30',
                    '18:45',
                    '19:00',
                    '19:15',
                    '19:30',
                    '19:45',
                    '20:00',
                    '20:15',
                    '20:30',
                    '20:45',
                    '21:00',
                    '21:15',
                    '21:30',
                    '21:45',
                    '22:00',
                    '22:15',
                    '22:30',
                    '22:45',
                    '23:00',
                    '23:15',
                    '23:30',
                    '23:45',
                ]
                let indx = this.start_date_time_format.indexOf(temp_start_time)
                this.start_date_time_format.splice(0,indx+1)
            }
        },
        changeStartDate(date){
            this.selected_temp_start_date = date;
            if(this.template_details.length > 1){ 
                this.showStartDateAlertModal = true;
                setTimeout(() => {
                    this.$modal.show("StartDateAlertModal");
                }, 1000);
            }else{
                this.pre_start_date = date;
                this.template_details[0].template_dates = []
                this.createJson.end_date = ''
                this.template_details[0].template_dates.push(this.createJson.start_date)
                this.disablePreTime();
            }
        },
        changeEndDate(date){
            this.selected_temp_end_date = date;
            if(this.template_details.length > 1){
                this.showEndDateAlertModal = true;
                setTimeout(() => {
                    this.$modal.show("EndDateAlertModal");
                }, 1000);
            }else{
                this.pre_end_date = date;
            }
        },
        hideEndDateAlertModal(){
            this.createJson.end_date =  this.pre_end_date;
            this.showEndDateAlertModal = false;
        },
        // resetEndDateTime(){
        //     this.template_details[0].template_dates = []
        //     this.createJson.end_date = ''
        //     //this.createJson.end_time = ''
        //     this.template_details[0].template_dates.push(this.createJson.start_date)
        //     this.disablePreTime();
        // },
        // resetData(){
        //     this.template_details.location.state = '',
        //     this.template_details.location.city = '',
        //     this.template_details.location.township = '',
        //     this.template_details.location.zip_code = '',
        //     this.template_details.location.street = '',
        //     this.template_details.meeting_location_vmodel = '',
        //     this.location.street = ''
        //     this.location.building_no = ''
        //     this.location.country = ''
        // },
        setIndex(index, place){
            this.location_index = index
            this.setPlace(place);
        },
        //Sets location
        setPlace(place) {
            //this.meeting_location_vmodel = place.formatted_address;
            let index = this.location_index
            this.showAddress = true;
            let currentPlace = place;
            let address = place.formatted_address.split(", ");
            let starting_name = address[address.length - 6] || "";
            this.template_details[index].location.street =
                 address[address.length - 4] || "";
            this.template_details[index].location.township =
                address[address.length - 3] || "";
            this.template_details[index].location.city = address[address.length - 3] || "";
            let statezip = address[address.length - 2] ?
                address[address.length - 2].split(" ") : ["", ""];
            if (address[address.length - 1].includes("-")) {
                let countrySelected = address[address.length - 1].split(" - ");
                countrySelected.forEach(x => {
                    if (this.countries.includes(x)) {
                        this.template_details[index].location.country = x;
                    } else {
                        this.template_details[index].location.country = "";
                    }
                });
            } else {
                this.template_details[index].location.country = address[address.length - 1];
            }
            this.template_details[index].location.state = statezip[0].match(/^[a-zA-Z]+$/) ?
                statezip[0] :
                statezip[1].match(/^[a-zA-Z]+$/) ?
                statezip[1] :
                "";
            this.template_details[index].location.zip_code = statezip[0].match(/^[0-9]+$/) ?
                statezip[0] :
                statezip[1].match(/^[0-9]+$/) ?
                statezip[1] :
                "";
                this.template_details[index].meeting_location_vmodel =
                        // (starting_name ? starting_name + ', ' : '') +
                        (this.template_details[index].location.street ? this.template_details[index].location.street + ', ' : '') +
                        (this.template_details[index].location.township ? this.template_details[index].location.township + ', ' : '') +
                        (this.template_details[index].location.city ? this.template_details[index].location.city + ', ' : '') +
                        (this.template_details[index].location.state ? this.template_details[index].location.state + ', ' : '') +
                        (this.template_details[index].location.zip_code ? this.template_details[index].location.zip_code + ', ' : '') +
                        (this.template_details[index].location.country ? this.template_details[index].location.country + ', ' : '')
            //this.template_details.location.address = this.meeting_location_vmodel;
            // this.template_details.location.meeting_location.latitude = currentPlace.geometry.location.lat();
            // this.template_details.location.meeting_location.longitude = currentPlace.geometry.location.lng();
        },
        errorHandler(err) {
            if (err.code == 1) {
                // alert("Error: Access is denied!");
            } else if (err.code == 2) {
                // alert("Error: Position is unavailable!");
            }
        },
        //Address calculates based on long and latt values
        getLocation(index) {
            this.template_details[index].meeting_location_vmodel = ""
            this.location_index = index
            if (navigator.geolocation) {
                // timeout at 60000 milliseconds (60 seconds)
                var options = {
                    enableHighAccuracy: false,
                    timeout: 30000, // milliseconds (30 seconds)
                    maximumAge: 600000
                }; // milliseconds (10 minutes)
                navigator.geolocation.getCurrentPosition(
                    this.showLocation,
                    this.errorHandler,
                    options
                );
            } else {
                alert("Sorry, browser does not support geolocation");
            }
        },
        //Address fields will be fetched when location icon clicks
        showLocation(position) {
            let index = this.location_index
            this.template_details[index].location.latitude = position.coords.latitude;
            this.template_details[index].location.longitude = position.coords.longitude;
            let latlongvalue = position.coords.latitude + "," + position.coords.longitude;
            let calllatlong = axios.create();
            delete calllatlong.defaults.headers.common['Authorization'];
            calllatlong.post("https://maps.googleapis.com/maps/api/geocode/json?latlng=" +
                    latlongvalue +
                    "&key=AIzaSyCQSEwELtCrUrLSfsqU0wX7QAHbLVQzUrY")
                .then(response => {
                    //this.meeting_location_vmodel = response.data.results[0].formatted_address
                    let address = response.data.results[0].formatted_address.split(", ");
                    this.showAddress = true;
                    this.template_details[index].location.street =
                        address[address.length - 4] || "";
                    this.template_details[index].location.township =
                        address[address.length - 3] || "";
                    this.template_details[index].location.city = address[address.length - 3] || "";
                    let statezip = address[address.length - 2] ?
                        address[address.length - 2].split(" ") : ["", ""];
                    this.template_details[index].location.zip_code = statezip[0].match(/^[0-9]+$/) ?
                        statezip[0] :
                        statezip[1].match(/^[0-9]+$/) ?
                        statezip[1] :
                        "";
                    this.template_details[index].location.state = statezip[0].match(/^[a-zA-Z]+$/) ?
                        statezip[0] :
                        statezip[1].match(/^[a-zA-Z]+$/) ?
                        statezip[1] :
                        "";
                    if (address[address.length - 1].includes("-")) {
                        let countrySelected = address[address.length - 1].split(" - ");
                        countrySelected.forEach(x => {
                            if (this.countries.includes(x)) {
                                this.template_details[index].location.country = x;
                            } else {
                                this.template_details[index].location.country = "";
                            }
                        });
                    } else {
                        this.template_details[index].location.country = address[address.length - 1];
                    }
                    this.template_details[index].meeting_location_vmodel =
                        (this.template_details[index].location.street ? this.template_details[index].location.street + ', ' : '') +
                        (this.template_details[index].location.township ? this.template_details[index].location.township + ', ' : '') +
                        (this.template_details[index].location.city ? this.template_details[index].location.city + ', ' : '') +
                        (this.template_details[index].location.state ? this.template_details[index].location.state + ', ' : '') +
                        (this.template_details[index].location.zip_code ? this.template_details[index].location.zip_code + ', ' : '') +
                        (this.template_details[index].location.country ? this.template_details[index].location.country + '.' : '')
                    //this.createJson.address = this.meeting_location_vmodel;
                        // + ", " +
                        // this
                        // .createJson.meeting_location.city + ", " + this.createJson.meeting_location
                        // .state +
                        // ", " + this.createJson.meeting_location.zip_code + ", " + this.createJson
                        // .meeting_location.country;
                })
                .catch(e => {
                    // this.errors.push(e)
                });
        },
        handleValidationError() {
            const firstField = Object.keys(this.errors.collect())[0];
            if(firstField.includes('multiselect')) {
                this.$refs[`${firstField}Input`].$el.focus();
            } else {
                this.$refs[`${firstField}Input`].focus();
            }
        },
        //Validates input data and redirects to preview page
        saveCampaign(){
            this.$validator.validateAll().then(result =>{
                if(this.createJson.start_time == ""){
                    this.is_start_time = true;
                }
                if(this.createJson.end_date == ""){
                    this.is_end_date = true;
                }
                if(this.createJson.end_time == ""){
                    this.is_end_time = true;
                }
                if(result){
                    // if(result == true){
                    //     if(this.createJson.selectedtemplate == "template1"){
                    //         EventBus.$emit("call_template1", this.createMainJsonData)
                    //     }
                    //     else if(this.createJson.selectedtemplate == "template2"){
                    //         EventBus.$emit("call_template2", this.createMainJsonData)
                    //     }
                    //     else if(this.createJson.selectedtemplate == "template3"){
                    //         EventBus.$emit("call_template3", this.createMainJsonData)
                    //     }
                    // }
                    let temp_ot_recipient = []
                    this.tags.forEach(x => {
                        x.email = x.text,
                        x.name = "",
                        x.phone = "",
                        x.id = "",
                        x.source = ""
                    })
                    temp_ot_recipient = this.tags
                    temp_ot_recipient.forEach(y => {
                        delete y['text']
                        delete y['tiClasses']
                    })
                    this.createMainJsonData.other_recipients = temp_ot_recipient
                    localStorage.setItem('email_template_data', JSON.stringify(this.createMainJsonData))
                    if(this.$route.params.id){
                        this.$router.push({
                            path: "/campaign/email/previewTemplateThree/"+this.$route.params.id
                        })
                    } else
                    this.$router.push({
                        path: "/campaign/email/previewTemplateThree/"
                    })
                } else{
                    return this.handleValidationError();
                }
            });
        },
        async loadCampaignDetails(){
            this.ajaxCallInProgress = true;
            this.disable_broadcast = true;
            let response = await this.getCampaignDetails(this.$route.params.id)
            this.campaign_details = response.response
            this.createJson.campaign_name = this.campaign_details.name
            this.createJson.author_name = this.campaign_details.author_name
            this.createJson.author_email = this.campaign_details.author_email
            //this.createJson.industry_type = this.campaign_details.industry_type
            this.createJson.campaign_type = this.campaign_details.type
            this.createJson.start_date = this.campaign_details.start_date
            this.createJson.start_time = this.campaign_details.start_time
            this.createJson.end_date = this.campaign_details.end_date
            //this.createJson.end_time = this.campaign_details.end_time
            this.createJson.send_now = this.campaign_details.send_now
            this.createJson.recurrence_days = this.campaign_details.recurrence ? this.campaign_details.recurrence[0].toUpperCase() + this.campaign_details.recurrence.substring(1) : ""
            this.createJson.currency = this.campaign_details.budget.symbol
            this.createJson.budget = this.campaign_details.budget.value
            this.createJson.description = this.campaign_details.description
            this.createJson.recipient_details = this.campaign_details.recipients
            if(this.campaign_details.other_recipients != null){
                this.tags = this.campaign_details.other_recipients
                if(this.tags){
                    this.tags.forEach(y => {
                        y.text = y.email
                    });
                }
            }
            this.createJson.is_customized = this.campaign_details.is_customized
            this.campaign_details.template_details.forEach((data_bind, data_bind_index) => {
                if(data_bind_index == 0){
                    this.template_details[data_bind_index].template_dates = data_bind.email_dates
                    this.template_details[data_bind_index].topic_name = data_bind.info.topic_name
                    this.template_details[data_bind_index].headline_url = data_bind.info.url_headline
                    this.template_details[data_bind_index].add_url = data_bind.info.url
                    this.template_details[data_bind_index].headline = data_bind.info.headline_name
                    this.template_details[data_bind_index].content = data_bind.info.headline_content
                    this.template_details[data_bind_index].phone_number = data_bind.phone_number
                    this.template_details[data_bind_index].location = data_bind.address
                    this.template_details[data_bind_index].facebook_url = data_bind.social_media.facebook
                    this.template_details[data_bind_index].insta_url = data_bind.social_media.instagram
                    this.template_details[data_bind_index].linkedin_url = data_bind.social_media.linkedin
                    this.template_details[data_bind_index].twitter_url = data_bind.social_media.twitter
                    if(data_bind.images.logo != ""){
                        this.template_details[data_bind_index].showLogoImageUpload = false
                        this.template_details[data_bind_index].logoImage.push({
                            name: data_bind.images.logo.slice(data_bind.images.logo.length - 20),
                            size: 0,
                            url: data_bind.images.logo
                        })
                    }
                    if(data_bind.images.banner_image != ""){
                        this.template_details[data_bind_index].showBannerImageUpload = false
                        this.template_details[data_bind_index].bannerImage.push({
                            name: data_bind.images.banner_image.slice(data_bind.images.banner_image.length - 20),
                            size: 0,
                            url: data_bind.images.banner_image
                        })
                    }
                    this.template_details[data_bind_index].meeting_location_vmodel =
                    (this.template_details[data_bind_index].location.street ? this.template_details[data_bind_index].location.street + ', ' : '') +
                    (this.template_details[data_bind_index].location.township ? this.template_details[data_bind_index].location.township + ', ' : '') +
                    (this.template_details[data_bind_index].location.city ? this.template_details[data_bind_index].location.city + ', ' : '') +
                    (this.template_details[data_bind_index].location.state ? this.template_details[data_bind_index].location.state + ', ' : '') +
                    (this.template_details[data_bind_index].location.zip_code ? this.template_details[data_bind_index].location.zip_code + ', ' : '') +
                    (this.template_details[data_bind_index].location.country ? this.template_details[data_bind_index].location.country + '. ' : '')
                } else if(data_bind_index > 0){
                    let logoImage = []
                    let bannerImage = []
                    let showLogoImageUpload = true
                    let showBannerImageUpload = true
                    let meeting_location_vmodel = ""
                    if(data_bind.images.logo != ""){
                        logoImage.push({
                            name: data_bind.images.logo.slice(data_bind.images.logo.length - 20),
                            size: 0,
                            url: data_bind.images.logo
                        })
                        showLogoImageUpload = false
                    }
                    if(data_bind.images.banner_image != ""){
                        bannerImage.push({
                            name: data_bind.images.banner_image.slice(data_bind.images.banner_image.length - 20),
                            size: 0,
                            url: data_bind.images.banner_image
                        })
                        showBannerImageUpload = false
                    }
                    meeting_location_vmodel = 
                    (data_bind.address.street ? data_bind.address.street + ', ': '') +
                    (data_bind.address.township ? data_bind.address.township + ', ': '') +
                    (data_bind.address.city ? data_bind.address.city + ', ': '') +
                    (data_bind.address.state ? data_bind.address.state + ', ': '') +
                    (data_bind.address.country ? data_bind.address.country + '. ': '') +
                    (data_bind.address.zip_code ? data_bind.address.zip_code : '')
                    this.template_details.push({
                        template_dates: data_bind.email_dates,
                        topic_name: data_bind.info.topic_name,
                        headline_url: data_bind.info.url_headline,
                        add_url: data_bind.info.url,
                        headline: data_bind.info.headline_name,
                        content: data_bind.info.headline_content,
                        phone_number: data_bind.phone_number,
                        meeting_location_vmodel: meeting_location_vmodel,
                        location:data_bind.address,
                        facebook_url: data_bind.social_media.facebook,
                        twitter_url: data_bind.social_media.twitter,
                        insta_url: data_bind.social_media.instagram,
                        linkedin_url: data_bind.social_media.linkedin,
                        logoImage: logoImage,
                        bannerImage: bannerImage,
                        showLogoImageUpload: showLogoImageUpload,
                        showBannerImageUpload: showBannerImageUpload,
                    })
                }
            })
            if(this.createJson.recurrence_days == 'Once'){
                this.callDisable = true;
            }else{
                this.callDisable = false;
            }
            this.pre_start_date = this.createJson.start_date;
            // this.createJson.topic_name = this.campaign_details.template_details.info.topic_name,
            // this.createJson.headline_url = this.campaign_details.template_details.info.url_headline,
            // this.createJson.add_url = this.campaign_details.template_details.info.url,
            // this.createJson.headline = this.campaign_details.template_details.info.headline_name,
            // this.createJson.content = this.campaign_details.template_details.info.headline_content,
            // this.createJson.meeting_location_vmodel = this.campaign_details.template_details.meeting_location_vmodel,
            // this.createJson.street = this.campaign_details.template_details.address.street,
            // this.location.country = this.campaign_details.template_details.address.country,
            // this.createJson.state = this.campaign_details.template_details.address.state,
            // this.createJson.city = this.campaign_details.template_details.address.city,
            // this.createJson.township = this.campaign_details.template_details.address.township,
            // this.createJson.zip_code = this.campaign_details.template_details.address.zip_code,
            // this.createJson.facebook_url = this.campaign_details.template_details.social_media.facebook,
            // this.createJson.twitter_url = this.campaign_details.template_details.social_media.twitter,
            // this.createJson.insta_url = this.campaign_details.template_details.social_media.instagram,
            // this.createJson.linkedin_url = this.campaign_details.template_details.social_media.linkedin,
            // this.phone_number = this.campaign_details.template_details.phone_number
            // if(this.campaign_details.template_details.images.logo != ""){
            //     this.logoImage.push({
            //         name: this.campaign_details.template_details.images.logo.slice(this.campaign_details.template_details.images.logo.length - 20),
            //         size: 0,
            //         url: this.campaign_details.template_details.images.logo
            //     })
            // }
            // if(this.campaign_details.template_details.images.banner_image != ""){
            //     this.bannerImage.push({
            //         name: this.campaign_details.template_details.images.banner_image.slice(this.campaign_details.template_details.images.banner_image.length - 20),
            //         size: 0,
            //         url: this.campaign_details.template_details.images.banner_image
            //     })
            // }
            // if(this.logoImage.length){
            //     this.showLogoImageUpload = false;
            // }
            // if(this.bannerImage.length){
            //     this.showBannerImageUpload = false;
            // }
            // this.meeting_location_vmodel =
            //     (this.createJson.street ? this.createJson.street + ', ' : '') +
            //     (this.createJson.township ? this.createJson.township + ', ' : '') +
            //     (this.createJson.city ? this.createJson.city + ', ' : '') +
            //     (this.createJson.state ? this.createJson.state + ', ' : '') +
            //     (this.createJson.zip_code ? this.createJson.zip_code + ', ' : '') +
            //     (this.location.country ? this.location.country + ', ' : '')
            this.disablePreTime();
            this.CheckDate()
            this.ajaxCallInProgress = false;
            //EventBus.$emit("edit_template_three_data", this.campaign_details.template_details)
        },
        showTempData(){
            this.show_temp_data = true
            setTimeout(() => {
                this.$modal.show("templateData")
            }, 500);
        },
        hideTempData(){
            this.show_temp_data = false
        },
        addCustomer(newTag) {
            const element = newTag;
            if (String(element).match(this.email_regex)) {
                // this.optionsRecipients.push({
                //     email: element
                // });
                this.createJson.recipient_details.push({
                    email: element,
                    name: "",
                    phone: "",
                });
            } else {
                this.$awn.success("As Your Email ID Was Not Valid It is Removed");
                this.invalidEmail = true;
                return;
            }
        },
        hidePreview(){
            this.preview_visible = false
        },
        previewImage(file) {
            let content_type = mime.lookup(file.name) ? mime.lookup(file.name) : 'application/octet-stream';
            file['content_type'] = content_type;
            this.preview_file = file;
            this.preview_visible = true;
        },
        async searchCustomerInside(key) {
            if (key) {
                this.search_term = key;
            }
            let params = {
                skip: this.skip,
                limit: this.limit,
                search_key: this.search_term,
                company_id: this.loggedInUser.company_id
            };
            let res = await this.getAssigned(params);
            this.optionsRecipients = res.response;
            this.count = 0;
            this.isLoading = false;
        },
        async reachedEndOfListCustomer(reached) {
            this.isVisible = reached;
            if (reached) {
                if (this.scrollableCustomer == false) {
                    this.isLoading = true;
                    let res = await this.getAssigned({
                        skip: this.optionsRecipients.length,
                        limit: 10,
                        search_key: this.search_term,
                        company_id: this.loggedInUser.company_id
                    });
                    if (res.response.length > 0) {
                        let tempFiles = res.response;
                        tempFiles.forEach(el => {
                            this.optionsRecipients.push(
                                el);
                        });
                        this.count += res.response.length;
                        this.isLoading = false;
                    } else {
                        this.scrollableCustomer = true;
                        this.isLoading = false;
                    }
                    this.isLoading = false;
                }
            }
        },
        deleteLogo(index) {
            this.template_details[index].logoImage = [];
            this.template_details[index].showLogoImageUpload = true;
        },
        deleteBannerImage(index) {
            this.template_details[index].bannerImage = [];
            this.template_details[index].showBannerImageUpload = true;
        },
        dropHandlerLogo(evt, index) {
            // Prevent default behavior (Prevent file from being opened)
            evt.preventDefault();
            // Use DataTransfer interface to access the file(s)
            [...evt.dataTransfer.files].forEach((file, i) => {
                this.uploadLogoImageFromDrop(file, index)
            });
        },
        dragOverHandlerLogo(evt) {
            // Prevent default behavior (Prevent file from being opened)
            evt.preventDefault();
        },
        uploadLogoImageFromDrop(event, index) {
            if(event) {
                var input = event;
            }
            if (input && event) {
                const CancelToken = axios.CancelToken;
                const source = CancelToken.source();
                let attachment = {
                    //id: uuidv4(),
                    name: input.name,
                    size: JSON.stringify(input.size),
                    source: source,
                    progress: 0,
                    created_time: new Date(),
                    error: ""
                }
                if (this.template_details[index].logoImage.length >= 1) {
                    this.$toasted.global.error("you're not allowed to upload more than 1 Logo")
                } else if (attachment.size > 5000 * 1000){
                    this.$toasted.global.error("Attachments Size Cannot Exceed 5mb")
                } else {
                this.template_details[index].logoImage.push(attachment)
                this.getResumableInsideURL(input, this.template_details[index].logoImage[this.template_details[index].logoImage.length - 1], index);
                }
            }
        },
        getResumableInsideURL(file, attachment, index) {
            this.isUploadingInProgress = true;
            this.template_details[index].showLogoImageUpload = false;
            attachment.uploading = true;
            let usage_type = {
                usage: "attachment"
            }
            let data = {
                file: attachment.name
            }
            data = new FormData()
            data.append('file',file)
            Object.keys(usage_type).map(e => {
                data.append(e, JSON.stringify(usage_type[e]))
            })
            this.$http.post('https://cloudapis.digicollect.com/external/upload_file', data,{
                onUploadProgress: function (progressEvent) {
                    let progress = parseInt(Math.round((progressEvent.loaded * 100) / progressEvent.total));
                    if (progress < 100) {
                        attachment.progress = progress;
                    }
                }.bind(this)
            })
            .then(response => {
                let resumable_url = response.data.url;
                attachment.url = resumable_url;
                attachment.progress = 100;
                attachment.uploading = false;
                this.isUploadingInProgress = false;
                this.template_details[index].showLogoImageUpload = false;
                delete attachment['source'];
            })
            .catch(error => {

            })
        },
        uploadLogoImage(event, index) {
            if(event) {
                var input = event.target;
            }
            if(event == undefined) {
                var input
                input = this.$refs.upload_inside.files
                input['files'] = []
                input.files.push({
                    lastModified : input[0].file.lastModified,
                    name : input[0].file.name,
                    size : input[0].file.size,
                    type : input[0].file.type,
                    webkitRelativePath : input[0].file.webkitRelativePath,
                    lastModifiedDate : input[0].file.lastModifiedDate
                })
                const CancelToken = axios.CancelToken;
                const source = CancelToken.source();
                let attachment = {
                    //id: uuidv4(),
                    name: input.files[0].name,
                    size: JSON.stringify(input.files[0].size),
                    source: source,
                    progress: 0,
                    created_time: new Date(),
                    error: "",
                    url:""
                }
                if (this.template_details[index].logoImage.length >= 1) {
                    this.$toasted.global.error("you're not allowed to upload more than 1 Logo")
                } else if (attachment.size > 5000 * 1000){
                    this.$toasted.global.error("Attachments Size Cannot Exceed 5mb")
                } else {
                this.template_details[index].logoImage.push(attachment)
                this.getResumableInsideURL(input[0].file, this.template_details[index].logoImage[this.template_details[index].logoImage.length - 1], index);
                }
            }
            if (input.files && input.files[0] && event) {
                const CancelToken = axios.CancelToken;
                const source = CancelToken.source();
                let attachment = {
                    //id: uuidv4(),
                    name: input.files[0].name,
                    size: JSON.stringify(input.files[0].size),
                    source: source,
                    progress: 0,
                    created_time: new Date(),
                    error: ""
                }
                if (this.template_details[index].logoImage.length >= 1) {
                    this.$toasted.global.error("you're not allowed to upload more than 1 Logo")
                } else if (attachment.size > 5000 * 1000){
                    this.$toasted.global.error("Attachments Size Cannot Exceed 5mb")
                } else {
                this.template_details[index].logoImage.push(attachment)
                this.getResumableInsideURL(input.files[0], this.template_details[index].logoImage[this.template_details[index].logoImage.length - 1], index);
                }
            }
        },
        dropHandlerBanner(evt, index) {
            // Prevent default behavior (Prevent file from being opened)
            evt.preventDefault();
            // Use DataTransfer interface to access the file(s)
            [...evt.dataTransfer.files].forEach((file, i) => {
                this.uploadBannerImageFromDrop(file, index)
            });
        },
        dragOverHandlerBanner(evt) {
            // Prevent default behavior (Prevent file from being opened)
            evt.preventDefault();
        },
        uploadBannerImageFromDrop(event, index) {
            if(event) {
                var input = event;
            }
            if (input && event) {
                const CancelToken = axios.CancelToken;
                const source = CancelToken.source();
                let attachment = {
                    //id: uuidv4(),
                    name: input.name,
                    size: JSON.stringify(input.size),
                    source: source,
                    progress: 0,
                    created_time: new Date(),
                    error: ""
                }
                if (this.template_details[index].bannerImage.length >= 1) {
                    this.$toasted.global.error("you're not allowed to upload more than 1 image")
                } else if (attachment.size > 5000 * 1000){
                    this.$toasted.global.error("Attachments Size Cannot Exceed 5mb")
                } else {
                this.template_details[index].bannerImage.push(attachment)
                this.getResumableURL(input, this.template_details[index].bannerImage[this.template_details[index].bannerImage.length - 1], index);
                }
            }
        },
        getResumableURL(file, attachment, index) {
            this.isUploadingInProgress = true;
            this.template_details[index].showBannerImageUpload = false;
            attachment.uploading = true;
            let usage_type = {
                usage: "attachment"
            }
            let data = {
                file: attachment.name
            }
            data = new FormData()
            data.append('file',file)
            Object.keys(usage_type).map(e => {
                data.append(e, JSON.stringify(usage_type[e]))
            })
            this.$http.post('https://cloudapis.digicollect.com/external/upload_file', data,{
                onUploadProgress: function (progressEvent) {
                    let progress = parseInt(Math.round((progressEvent.loaded * 100) / progressEvent.total));
                    if (progress < 100) {
                        attachment.progress = progress;
                    }
                }.bind(this)
            })
            .then(response => {
                let resumable_url = response.data.url;
                attachment.url = resumable_url;
                attachment.progress = 100;
                attachment.uploading = false;
                this.isUploadingInProgress = false;
                this.template_details[index].showBannerImageUpload = false;
                delete attachment['source'];
            })
            .catch(error => {

            })
        },
        uploadBannerImage(event, index) {
            if(event) {
                var input = event.target;
            }
            if(event == undefined) {
                var input
                input = this.$refs.upload.files
                input['files'] = []
                input.files.push({
                    lastModified : input[0].file.lastModified,
                    name : input[0].file.name,
                    size : input[0].file.size,
                    type : input[0].file.type,
                    webkitRelativePath : input[0].file.webkitRelativePath,
                    lastModifiedDate : input[0].file.lastModifiedDate
                })
                const CancelToken = axios.CancelToken;
                const source = CancelToken.source();
                let attachment = {
                    //id: uuidv4(),
                    name: input.files[0].name,
                    size: JSON.stringify(input.files[0].size),
                    source: source,
                    progress: 0,
                    created_time: new Date(),
                    error: "",
                    url:""
                }
                if (this.template_details[index].bannerImage.length >= 1) {
                    this.$toasted.global.error("you're not allowed to upload more than 1 image")
                } else if (attachment.size > 5000 * 1000){
                    this.$toasted.global.error("Attachments Size Cannot Exceed 5mb")
                } else {
                this.template_details[index].bannerImage.push(attachment)
                this.getResumableURL(input[0].file, this.template_details[index].bannerImage[this.template_details[index].bannerImage.length - 1], index);
                }
            }
            if (input.files && input.files[0] && event) {
                const CancelToken = axios.CancelToken;
                const source = CancelToken.source();
                let attachment = {
                    //id: uuidv4(),
                    name: input.files[0].name,
                    size: JSON.stringify(input.files[0].size),
                    source: source,
                    progress: 0,
                    created_time: new Date(),
                    error: ""
                }
                if (this.template_details[index].bannerImage.length >= 1) {
                    this.$toasted.global.error("you're not allowed to upload more than 1 image")
                } else if (attachment.size > 5000 * 1000){
                    this.$toasted.global.error("Attachments Size Cannot Exceed 5mb")
                } else {
                this.template_details[index].bannerImage.push(attachment)
                this.getResumableURL(input.files[0], this.template_details[index].bannerImage[this.template_details[index].bannerImage.length - 1], index);
                }
            }
        },
    },
    mounted(){
        this.createJson.author_name = this.loggedInUser.full_name;
        this.createJson.author_email = this.loggedInUser.login_id;
        this.createJson.currency = this.loggedInUser.currency.symbol;
        this.template_details[0].template_dates.push(this.createJson.start_date)
        if(!this.$route.params.id){
            var temp_start_time = ""
            var curr_time = moment(new Date().toUTCString()).format("HH:mm");
            if(parseInt(curr_time.substring(3)) >= 0 && parseInt(curr_time.substring(3)) < 15){
                temp_start_time = curr_time.slice(0,3) + '00'
            } else if(parseInt(curr_time.substring(3)) >= 15 && parseInt(curr_time.substring(3)) < 30){
                temp_start_time = curr_time.slice(0,3) + '15'
            } else if(parseInt(curr_time.substring(3)) >= 30 && parseInt(curr_time.substring(3)) < 45){
                temp_start_time = curr_time.slice(0,3) + '30'
            } else if(parseInt(curr_time.substring(3)) >= 45){
                temp_start_time = curr_time.slice(0,3) + '45'
            }
            this.start_date_time_format = [
                '00:00',
                '00:15',
                '00:30',
                '00:45',
                '01:00',
                '01:15',
                '01:30',
                '01:45',
                '02:00',
                '02:15',
                '02:30',
                '02:45',
                '03:00',
                '03:15',
                '03:30',
                '03:45',
                '04:00',
                '04:15',
                '04:30',
                '04:45',
                '05:00',
                '05:15',
                '05:30',
                '05:45',
                '06:00',
                '06:15',
                '06:30',
                '06:45',
                '07:00',
                '07:15',
                '07:30',
                '07:45',
                '08:00',
                '08:15',
                '08:30',
                '08:45',
                '09:00',
                '09:15',
                '09:30',
                '09:45',
                '10:00',
                '10:15',
                '10:30',
                '10:45',
                '11:00',
                '11:15',
                '11:30',
                '11:45',
                '12:00',
                '12:15',
                '12:30',
                '12:45',
                '13:00',
                '13:15',
                '13:30',
                '13:45',
                '14:00',
                '14:15',
                '14:30',
                '14:45',
                '15:00',
                '15:15',
                '15:30',
                '15:45',
                '16:00',
                '16:15',
                '16:30',
                '16:45',
                '17:00',
                '17:15',
                '17:30',
                '17:45',
                '18:00',
                '18:15',
                '18:30',
                '18:45',
                '19:00',
                '19:15',
                '19:30',
                '19:45',
                '20:00',
                '20:15',
                '20:30',
                '20:45',
                '21:00',
                '21:15',
                '21:30',
                '21:45',
                '22:00',
                '22:15',
                '22:30',
                '22:45',
                '23:00',
                '23:15',
                '23:30',
                '23:45',
            ]
            let indx = this.start_date_time_format.indexOf(temp_start_time)
            this.start_date_time_format.splice(0,indx+1)
        }
        EventBus.$on("new_content", (new_content)=>{
            this.ajaxCallLoadContentDetails = true;
            this.template_details = new_content
            setTimeout(() => {
                this.ajaxCallLoadContentDetails = false;
            }, 1000);
        })
        EventBus.$on("back_from_preview_campaign", ()=>{
            if(!this.$route.params.id){
                if(localStorage.getItem("email_template_data")){
                    let email_template_data = JSON.parse(localStorage.getItem("email_template_data"))
                    this.createJson.campaign_name = email_template_data.campaign_name
                    this.createJson.author_name = email_template_data.author_name
                    this.createJson.author_email = email_template_data.author_email
                    //this.createJson.industry_type = email_template_data.industry_type
                    this.createJson.campaign_type = email_template_data.campaign_type
                    this.createJson.start_date = email_template_data.start_date
                    this.createJson.start_time = email_template_data.start_time
                    this.createJson.end_date = email_template_data.end_date
                    this.createJson.end_time = email_template_data.end_time
                    this.createJson.recurrence_days = email_template_data.recurrence_days
                    this.createJson.budget = email_template_data.budget
                    this.createJson.description = email_template_data.description
                    this.createJson.recipient_details = email_template_data.recipient_details
                    this.createJson.selectedtemplate = email_template_data.selectedtemplate
                    this.createJson.send_now = email_template_data.send_now
                    this.createJson.is_customized = email_template_data.is_customized
                    this.template_details = email_template_data.template_details
                    this.attachmentNew = email_template_data.attachments
                    if(email_template_data.other_recipients != null){
                        this.tags = email_template_data.other_recipients
                        if(this.tags){
                            this.tags.forEach(x => {
                                x.text = x.email
                            });
                        }
                    }
                    if(email_template_data.recurrence_days == 'Once'){
                        this.callDisable = true;
                    } else {
                        this.callDisable = false;
                    }
                    // this.createJson.topic_name = email_template_data.topic_name,
                    // this.createJson.headline_url = email_template_data.headline_url,
                    // this.createJson.add_url = email_template_data.add_url,
                    // this.createJson.headline = email_template_data.headline,
                    // this.createJson.content = email_template_data.content,
                    // this.createJson.meeting_location_vmodel = email_template_data.meeting_location_vmodel,
                    // this.createJson.street = email_template_data.street,
                    // this.location.country = email_template_data.country,
                    // this.createJson.state = email_template_data.state,
                    // this.createJson.city = email_template_data.city,
                    // this.createJson.township = email_template_data.township,
                    // this.createJson.zip_code = email_template_data.zip_code,
                    // this.createJson.facebook_url = email_template_data.facebook_url,
                    // this.createJson.twitter_url = email_template_data.twitter_url,
                    // this.createJson.insta_url = email_template_data.insta_url,
                    // this.createJson.linkedin_url = email_template_data.linkedin_url,
                    // this.phone_number = email_template_data.phone_number,
                    // this.logoImage = email_template_data.logo,
                    // this.bannerImage = email_template_data.banner_image
                    // if(this.logoImage.length){
                    //     this.showLogoImageUpload = false;
                    // }
                    // if(this.bannerImage.length){
                    //     this.showBannerImageUpload = false;
                    // }
                    //this.CheckDate()
                }
            }
        })
        if(this.$route.params.id){
            this.campaign_id = this.$route.params.id
            this.loadCampaignDetails()
        }
        this.pre_start_date = this.createJson.start_date;
    },
    beforeRouteLeave (to, from, next) {
        if(to.path != `/campaign/email/previewTemplateThree/` && to.path != `/campaign/email/previewTemplateThree/${this.$route.params.id}`){
            // const answer = window.confirm('Do you really want to leave?');
            // if (answer) {
            //     next()
            // } else {
            //     next(false)
            // }
            let message = "<img src='/static/images/exclamation-yellow.svg' class='d-block h-100px mx-auto mb-5'/><br><div class='d-block'>Unsaved Campaign Data would be lost, Do you want to proceed?</div>";

            let options = {
                html: true,
                loader: false,
                reverse: false, // switch the button positions (left to right, and vise versa)
                okText: 'Yes',
                cancelText: 'No',
                animation: 'fade',
                type: 'basic',
                verification: 'continue', // for hard confirm, user will be prompted to type this to enable the proceed button
                verificationHelp: 'Type "[+:verification]" below to confirm', // Verification help text. [+:verification] will be matched with 'options.verification' (i.e 'Type "continue" below to confirm')
                backdropClose: true,
            };
            this.$dialog.confirm(message, options)
			.then(function () {
				next();
			})
			.catch(function () {
				next(false);
			});
        } else {
            next()
        }
    },
    computed: {
        isInputDisabled() {
            return this.tags.length >= this.maxTags;
        },
        loggedInUser() {
            return this.$store.state.loggedInUser;
        },
        current_date() {
            var date = new Date();
            date.setDate(date.getDate() + 1);
            return date;
        },
        createMainJsonData(){
            return {
                campaign_name: this.createJson.campaign_name,
                author_name: this.createJson.author_name,
                author_email: this.createJson.author_email,
                //industry_type: this.createJson.industry_type,
                campaign_type: this.createJson.campaign_type,
                start_date: this.createJson.start_date,
                start_time: this.createJson.start_time,
                end_date: this.createJson.end_date,
                //end_time: this.createJson.end_time,
                recurrence_days: this.createJson.recurrence_days,
                currency: this.createJson.currency,
                budget: this.createJson.budget,
                description: this.createJson.description,
                recipient_details: this.createJson.recipient_details,
                other_recipients: this.tags,
                selectedtemplate: this.createJson.selectedtemplate,
                send_now: this.createJson.send_now,
                is_customized: this.createJson.is_customized,
                template_details: this.template_details,
                attachments: this.attachmentNew
                // topic_name: this.createJson.topic_name,
                // headline_url: this.createJson.headline_url,
                // add_url: this.createJson.add_url,
                // headline: this.createJson.headline,
                // content: this.createJson.content,
                // phone_number: this.phone_number,
                // meeting_location_vmodel: this.createJson.meeting_location_vmodel,
                // street: this.createJson.street,
                // country: this.location.country,
                // state: this.createJson.state,
                // city: this.createJson.city,
                // township: this.createJson.township,
                // zip_code: this.createJson.zip_code,
                // facebook_url: this.createJson.facebook_url,
                // twitter_url: this.createJson.twitter_url,
                // insta_url: this.createJson.insta_url,
                // linkedin_url: this.createJson.linkedin_url,
                // logo: this.logoImage,
                // banner_image: this.bannerImage
            }
        },
    },
    created() {
        const dict = {
            custom: {
                campaign_mobile_number: {
                    min: () => "Phone Number must contain more than 9 numbers",
                }
            }
        };
        this.$validator.localize("en", dict);
    },
    watch: {
        template_details() {
            if(this.template_details.length == 1){
                this.createJson.is_customized = false;
            } else {
                this.createJson.is_customized = true;
            }
        }
    },
}
</script>
<style scoped>
    .add-new-field{
        background-color: transparent;
        outline: 0 none !important;
    }
    .main-div {
        background: #fff;
        border-top-right-radius: 10px;
        border-top-left-radius: 10px;
        border-bottom-right-radius: 10px;
        border-bottom-left-radius: 10px;
        padding-top: 10px;
        padding-bottom: 10px;
    }

    .create-company-container {
        background-color: #fff;
        padding: 0px 0 0px 0;
        border-radius: 5px;
    }

    .create-company-header {
        padding: 9.9px 15px;
        background-color: #00448b;
    }
    .input-label {
        font-weight: 600;
        line-height: 1.5;
        letter-spacing: 0.39px;
        text-align: left;
        color: #00448b;
        padding: 0 0 6px 0px;
        font-size: 14px;
    }
    .input-field {
        border-radius: 6px !important;
        border: solid 0.5px #3f3f3f;
        background-color: #fff;
        padding: 8px 10px;
        width: 100% !important;
        height: 40px;
        color: black;
        font-size: 14px !important;
        font-weight: 600;
    }
    .input-width {
        border-radius: 5px !important;
        border: solid 0.5px #3f3f3f;
        background-color: #fff;
        padding: 8px 10px;
        width: 100% !important;
        height: 40px !important;
    }
    .btn-new-cancel {
        color: #d51650;
        background-color: #fff;
        border-radius: 5px;
        text-transform: none;
        font-weight: 600;
        border: 1px solid #d51650;
        line-height: 30px;
        box-shadow: none;
    }
    .btn-new-save {
        border: 2px solid #1f8122;
        color:#fff;
        line-height: 30px;
        border-radius: 5px;
        background-color: #1f8122;
        text-transform: capitalize;
    }
    .mx-datepicker.date-white .mx-input-wrapper input.mx-input {
        height: 32px !important;
        color: #fff !important;
        font-weight: 600 !important;
        font-size: 13px !important;
    }
    .mx-input {
        display: inline-block;
        height: 0px !important;
    }
    .v-hidden {
        visibility: hidden;
    }

    i,
    [class^="icon-"] {
        line-height: 0px !important;
    }
    .text-green {
        color: #008a63 !important;
    }
    .pointer-event {
        background-color: #fff !important;
    }
    .text-secondary {
        color: #00448b !important;
    }
    .text-line {
        text-decoration :none !important;
    }
    .recipients-box {
        border-radius: 5px;
        width: 100%;
        height:auto;
        /* overflow:scroll; */
        max-height:500px;
    }

    .custom-control {
        position: relative;
        display: block;
        min-height: 1.5rem;
        padding-left: 1.5rem;
    }
    .custom-control.image-checkbox {
        position: relative;
        padding-left: 0;
        border: 1px solid #005dae;
        border-radius: 10px;
        width: 150px;
    }
    .custom-control-input {
        position: absolute;
        z-index: -1;
        opacity: 0;
        right: 0px;
    }
    input.custom-control-input[type=radio], input.custom-control-input[type=radio] {
        box-sizing: border-box;
        padding: 0;
    }
    .custom-control-label-image {
        position: relative;
        margin-bottom: 0;
        vertical-align: top;
    }
    .custom-control.image-checkbox label {
        cursor: pointer;
        padding: 5px;
        height: 136px;
    }
    /* .custom-control-label-image::before {
        position: absolute;
        top: 5px;
        right: -1.5rem;
        display: block;
        width: 1.8rem;
        height: 1.8rem;
        pointer-events: none;
        content: "";
        background-color: #fff;
        border: #adb5bd solid 2px;
    } */
    /* .custom-control-label-image::after {
        position: absolute;
        top: 5px;
        right: -1.5rem;
        display: block;
        width: 1.8rem;
        height: 1.8rem;
        content: "";
        background: no-repeat 50%/50% 50%;
    } */
    /* .custom-control-label-image::before, .custom-file-label, .custom-select {
        transition: background-color .15s ease-in-out,border-color .15s ease-in-out,box-shadow .15s ease-in-out;
    } */
    /* .custom-checkbox-image .custom-control-label-image::before {
        border-radius: 4px;
    }
    .custom-control.image-checkbox label:before {
        border-color: #adb5bd;
        background-color: transparent;
    }
    .custom-control.image-checkbox label:after {
        transition: opacity .3s ease;
        opacity: 0;
        right: 4px;
        z-index: 1;
    }
    .custom-control.image-checkbox label:before {
        transition: opacity .3s ease;
        opacity: 1;
        right: 4px;
        z-index: 1;
    }
    .custom-control-input:checked~.custom-control-label-image::before {
        color: #fff;
        border-color: #007bff;
        background-color: #007bff;
    }
    .custom-checkbox-image .custom-control-input:checked~.custom-control-label-image::after {
        background-image: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 8 8'%3e%3cpath fill='%23fff' d='M6.564.75l-3.59 3.612-1.538-1.55L0 4.26 2.974 7.25 8 2.193z'/%3e%3c/svg%3e");
    }
    .custom-control.image-checkbox .custom-control-input:checked ~ .custom-control-label-image:after, .custom-control.image-checkbox .custom-control-input:checked ~ .custom-control-label-image:before {
        opacity: 0;
    }
    .custom-control.image-checkbox label img {
        border-radius: 2.5px;
    } */
    .h-label{
        padding-right:10px;
        font-weight: 600;
        line-height: 1.5;
        letter-spacing: 0.39px;
        text-align: left;
        color: #00448b;
        font-size: 14px;
        background-color: #f8f8f8 !important;
    }
    .h-line{
        height: 12px;
        border-bottom: 2px solid #ccc;
        text-align: left
    }
    .icon-data{
        padding-left: 30px;
        background-size: 20px !important;
        background-position: 2% 42% !important;
        font-family: 'Poppins', sans-serif !important;
    }
    .icon-face-link {
        background: url("https://storage.googleapis.com/5e8dbf9ac9ece9d5bf0786f0/598b84ab-f2be-40a0-a1d6-bed8c747a012.png") no-repeat left;
        padding-left: 38px;
    }
    .icon-insta-link {
        background: url("https://storage.googleapis.com/5e8dbf9ac9ece9d5bf0786f0/efb3d282-9581-4712-9bd8-e897eadec524.png") no-repeat left;
        padding-left: 38px;
    }
    .icon-twit-link {
        background: url("https://storage.googleapis.com/5e8dbf9ac9ece9d5bf0786f0/07397637-cd28-4f17-8e55-b1a233a0613e.png") no-repeat left;
        padding-left: 38px;
    }
    .icon-link {
        background: url("https://storage.googleapis.com/5e8dbf9ac9ece9d5bf0786f0/68ed13c1-1fae-4803-b032-7feec568de10.png") no-repeat left;
        padding-left: 38px;
    }
    .custom-control:hover .img {
        opacity: 0.3;
    }

    .custom-control:hover .middle {
        opacity: 1;
    }
    .img {
        opacity: 1;
        display: block;
        width: 140px;
        height: 130px;
        transition: .5s ease;
        backface-visibility: hidden;
    }
    .middle {
        transition: .5s ease;
        opacity: 0;
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        -ms-transform: translate(-50%, -50%);
        text-align: center;
    }
    .icon-css{
        color:#000;
        width:24px !important;
        z-index: 99;
    }
    .outer-checkbox{
        width: 100%;
        position: absolute;
        transform: translate(-50%, -50%);
        top: 50%;
        left: 50%;
        display: grid;
        place-items: center;
    }
    .inner-checkbox{
        height: 200px;
        width: 200px;
        background-color: #fff;
        box-shadow: 0 0 25px rgba(17, 1, 68, 0.08);
        border-radius: 8px;
        position: relative;
        cursor: pointer;
    }
    .templateimage-name {
        font-size: 13px;
        font-weight: normal;
        font-stretch: normal;
        font-style: normal;
        line-height: 1.56;
        letter-spacing: 0.69px;
        text-align: left;
        color: #261212;
        text-align: center;
        margin-top: 8px;
    }
    .add-button{
        color: #226BD3;
        background-color: #fff;
        font-weight: 600;
        cursor: pointer;
    }
    .choose-file{
        color: #0375F3;
        font-weight: 600;
        font-size: 14px;
    }
    .img-file{
        width: 36px;
        height: 40px;
    }
    .custom__tag {
        align-items: end !important;
    }
    .text-orange{
        color: #ff9a06;
    }
    .content-details-div{
        background-color: #f8f8f8 !important;
        padding: 0px 30px;
        margin-top: 20px;
    }
    .add-another{
        font-size: 14px;
        color: #0375F3;
        text-align: right !important;
    }
    @media screen and (max-width: 767px) {
		.margin-res-mx-767 {
            margin-top: 20px !important;
		}
	}
    @media screen and (max-width: 575px) {
		.margin-res-mx-575 {
            margin-left: 7px !important;
		}
	}
    .attachment-bg {
        background-color: #fff !important;
        border: 1.5px dashed #89898d;
        padding: 15px;
        border-radius: 10px;
        width: 100%;
    }
    .upload-img {
        margin-left: 52px;
        width: 42px;
        margin-bottom: 12px;
    }
    .btn-new-primary {
        color: #fff;
        background-color: #00448b;
        border-color: #00448b;
        box-shadow: none !important;
        font-weight: 500;
    }
</style>



// WEBPACK FOOTER //
// src/components/Campaign/Email/CreateCampaignEmail.vue